// tslint:disable
/// <reference path="./custom.d.ts" />
/**
 * Swagger NewRetail
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as globalImportUrl from 'url';
import globalAxios from 'axios';
import { BASE_PATH, BaseAPI, RequiredError } from './base';
/**
 * AccessListApi - axios parameter creator
 * @export
 */
export var AccessListApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary アクセス履歴一覧
         * @param {AccessListSearch} accessListSearch
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessListList: function (accessListSearch, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'accessListSearch' is not null or undefined
            if (accessListSearch === null || accessListSearch === undefined) {
                throw new RequiredError('accessListSearch', 'Required parameter accessListSearch was null or undefined when calling accessListList.');
            }
            var localVarPath = "/access_list/list";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'POST' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("AccessListSearch" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(accessListSearch !== undefined ? accessListSearch : {}) : (accessListSearch || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * AccessListApi - functional programming interface
 * @export
 */
export var AccessListApiFp = function (configuration) {
    return {
        /**
         *
         * @summary アクセス履歴一覧
         * @param {AccessListSearch} accessListSearch
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessListList: function (accessListSearch, options) {
            var localVarAxiosArgs = AccessListApiAxiosParamCreator(configuration).accessListList(accessListSearch, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
    };
};
/**
 * AccessListApi - factory interface
 * @export
 */
export var AccessListApiFactory = function (configuration, basePath, axios) {
    return {
        /**
         *
         * @summary アクセス履歴一覧
         * @param {AccessListSearch} accessListSearch
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessListList: function (accessListSearch, options) {
            return AccessListApiFp(configuration).accessListList(accessListSearch, options)(axios, basePath);
        },
    };
};
/**
 * AccessListApi - object-oriented interface
 * @export
 * @class AccessListApi
 * @extends {BaseAPI}
 */
var AccessListApi = /** @class */ (function (_super) {
    __extends(AccessListApi, _super);
    function AccessListApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary アクセス履歴一覧
     * @param {AccessListSearch} accessListSearch
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccessListApi
     */
    AccessListApi.prototype.accessListList = function (accessListSearch, options) {
        return AccessListApiFp(this.configuration).accessListList(accessListSearch, options)(this.axios, this.basePath);
    };
    return AccessListApi;
}(BaseAPI));
export { AccessListApi };
/**
 * AnalyzeApi - axios parameter creator
 * @export
 */
export var AnalyzeApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary 分析対象取得
         * @param {number} posFlag pos-flag：分析区分：0：両方　1：ID-POS　2：POS　省略可。省略時は両方返却する
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        analyzeGet: function (posFlag, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'posFlag' is not null or undefined
            if (posFlag === null || posFlag === undefined) {
                throw new RequiredError('posFlag', 'Required parameter posFlag was null or undefined when calling analyzeGet.');
            }
            var localVarPath = "/analyze/{pos_flag}"
                .replace("{" + "pos_flag" + "}", encodeURIComponent(String(posFlag)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 分析条件画面対象取得
         * @param {InlineObject31} [inlineObject31]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        analyzeInit: function (inlineObject31, options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/analyze/init";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'POST' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("InlineObject31" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(inlineObject31 !== undefined ? inlineObject31 : {}) : (inlineObject31 || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 分析実施（分析予約実施も含む）
         * @param {InlineObject32} [inlineObject32]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        analyzeStart: function (inlineObject32, options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/analyze/start";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'POST' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("InlineObject32" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(inlineObject32 !== undefined ? inlineObject32 : {}) : (inlineObject32 || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * AnalyzeApi - functional programming interface
 * @export
 */
export var AnalyzeApiFp = function (configuration) {
    return {
        /**
         *
         * @summary 分析対象取得
         * @param {number} posFlag pos-flag：分析区分：0：両方　1：ID-POS　2：POS　省略可。省略時は両方返却する
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        analyzeGet: function (posFlag, options) {
            var localVarAxiosArgs = AnalyzeApiAxiosParamCreator(configuration).analyzeGet(posFlag, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary 分析条件画面対象取得
         * @param {InlineObject31} [inlineObject31]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        analyzeInit: function (inlineObject31, options) {
            var localVarAxiosArgs = AnalyzeApiAxiosParamCreator(configuration).analyzeInit(inlineObject31, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary 分析実施（分析予約実施も含む）
         * @param {InlineObject32} [inlineObject32]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        analyzeStart: function (inlineObject32, options) {
            var localVarAxiosArgs = AnalyzeApiAxiosParamCreator(configuration).analyzeStart(inlineObject32, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
    };
};
/**
 * AnalyzeApi - factory interface
 * @export
 */
export var AnalyzeApiFactory = function (configuration, basePath, axios) {
    return {
        /**
         *
         * @summary 分析対象取得
         * @param {number} posFlag pos-flag：分析区分：0：両方　1：ID-POS　2：POS　省略可。省略時は両方返却する
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        analyzeGet: function (posFlag, options) {
            return AnalyzeApiFp(configuration).analyzeGet(posFlag, options)(axios, basePath);
        },
        /**
         *
         * @summary 分析条件画面対象取得
         * @param {InlineObject31} [inlineObject31]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        analyzeInit: function (inlineObject31, options) {
            return AnalyzeApiFp(configuration).analyzeInit(inlineObject31, options)(axios, basePath);
        },
        /**
         *
         * @summary 分析実施（分析予約実施も含む）
         * @param {InlineObject32} [inlineObject32]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        analyzeStart: function (inlineObject32, options) {
            return AnalyzeApiFp(configuration).analyzeStart(inlineObject32, options)(axios, basePath);
        },
    };
};
/**
 * AnalyzeApi - object-oriented interface
 * @export
 * @class AnalyzeApi
 * @extends {BaseAPI}
 */
var AnalyzeApi = /** @class */ (function (_super) {
    __extends(AnalyzeApi, _super);
    function AnalyzeApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary 分析対象取得
     * @param {number} posFlag pos-flag：分析区分：0：両方　1：ID-POS　2：POS　省略可。省略時は両方返却する
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnalyzeApi
     */
    AnalyzeApi.prototype.analyzeGet = function (posFlag, options) {
        return AnalyzeApiFp(this.configuration).analyzeGet(posFlag, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary 分析条件画面対象取得
     * @param {InlineObject31} [inlineObject31]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnalyzeApi
     */
    AnalyzeApi.prototype.analyzeInit = function (inlineObject31, options) {
        return AnalyzeApiFp(this.configuration).analyzeInit(inlineObject31, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary 分析実施（分析予約実施も含む）
     * @param {InlineObject32} [inlineObject32]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnalyzeApi
     */
    AnalyzeApi.prototype.analyzeStart = function (inlineObject32, options) {
        return AnalyzeApiFp(this.configuration).analyzeStart(inlineObject32, options)(this.axios, this.basePath);
    };
    return AnalyzeApi;
}(BaseAPI));
export { AnalyzeApi };
/**
 * AnalyzeDetailApi - axios parameter creator
 * @export
 */
export var AnalyzeDetailApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary 分析明細ダウンロード（IF00014）
         * @param {string} slug 対象分析明細名
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        analyzeDetailDownload: function (slug, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'slug' is not null or undefined
            if (slug === null || slug === undefined) {
                throw new RequiredError('slug', 'Required parameter slug was null or undefined when calling analyzeDetailDownload.');
            }
            var localVarPath = "/analyze_detail/download/{slug}"
                .replace("{" + "slug" + "}", encodeURIComponent(String(slug)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 分析明細一覧（IF00014）
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        analyzeDetailList: function (options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/analyze_detail/list";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * AnalyzeDetailApi - functional programming interface
 * @export
 */
export var AnalyzeDetailApiFp = function (configuration) {
    return {
        /**
         *
         * @summary 分析明細ダウンロード（IF00014）
         * @param {string} slug 対象分析明細名
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        analyzeDetailDownload: function (slug, options) {
            var localVarAxiosArgs = AnalyzeDetailApiAxiosParamCreator(configuration).analyzeDetailDownload(slug, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary 分析明細一覧（IF00014）
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        analyzeDetailList: function (options) {
            var localVarAxiosArgs = AnalyzeDetailApiAxiosParamCreator(configuration).analyzeDetailList(options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
    };
};
/**
 * AnalyzeDetailApi - factory interface
 * @export
 */
export var AnalyzeDetailApiFactory = function (configuration, basePath, axios) {
    return {
        /**
         *
         * @summary 分析明細ダウンロード（IF00014）
         * @param {string} slug 対象分析明細名
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        analyzeDetailDownload: function (slug, options) {
            return AnalyzeDetailApiFp(configuration).analyzeDetailDownload(slug, options)(axios, basePath);
        },
        /**
         *
         * @summary 分析明細一覧（IF00014）
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        analyzeDetailList: function (options) {
            return AnalyzeDetailApiFp(configuration).analyzeDetailList(options)(axios, basePath);
        },
    };
};
/**
 * AnalyzeDetailApi - object-oriented interface
 * @export
 * @class AnalyzeDetailApi
 * @extends {BaseAPI}
 */
var AnalyzeDetailApi = /** @class */ (function (_super) {
    __extends(AnalyzeDetailApi, _super);
    function AnalyzeDetailApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary 分析明細ダウンロード（IF00014）
     * @param {string} slug 対象分析明細名
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnalyzeDetailApi
     */
    AnalyzeDetailApi.prototype.analyzeDetailDownload = function (slug, options) {
        return AnalyzeDetailApiFp(this.configuration).analyzeDetailDownload(slug, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary 分析明細一覧（IF00014）
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnalyzeDetailApi
     */
    AnalyzeDetailApi.prototype.analyzeDetailList = function (options) {
        return AnalyzeDetailApiFp(this.configuration).analyzeDetailList(options)(this.axios, this.basePath);
    };
    return AnalyzeDetailApi;
}(BaseAPI));
export { AnalyzeDetailApi };
/**
 * AnalyzeMasterApi - axios parameter creator
 * @export
 */
export var AnalyzeMasterApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary 分析マスタダウンロード（IF00015）
         * @param {string} slug 対象分析マスタ名
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        analyzeMasterDownload: function (slug, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'slug' is not null or undefined
            if (slug === null || slug === undefined) {
                throw new RequiredError('slug', 'Required parameter slug was null or undefined when calling analyzeMasterDownload.');
            }
            var localVarPath = "/analyze_master/download/{slug}"
                .replace("{" + "slug" + "}", encodeURIComponent(String(slug)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 分析マスタ一覧（IF00015）
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        analyzeMasterList: function (options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/analyze_master/list";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * AnalyzeMasterApi - functional programming interface
 * @export
 */
export var AnalyzeMasterApiFp = function (configuration) {
    return {
        /**
         *
         * @summary 分析マスタダウンロード（IF00015）
         * @param {string} slug 対象分析マスタ名
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        analyzeMasterDownload: function (slug, options) {
            var localVarAxiosArgs = AnalyzeMasterApiAxiosParamCreator(configuration).analyzeMasterDownload(slug, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary 分析マスタ一覧（IF00015）
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        analyzeMasterList: function (options) {
            var localVarAxiosArgs = AnalyzeMasterApiAxiosParamCreator(configuration).analyzeMasterList(options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
    };
};
/**
 * AnalyzeMasterApi - factory interface
 * @export
 */
export var AnalyzeMasterApiFactory = function (configuration, basePath, axios) {
    return {
        /**
         *
         * @summary 分析マスタダウンロード（IF00015）
         * @param {string} slug 対象分析マスタ名
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        analyzeMasterDownload: function (slug, options) {
            return AnalyzeMasterApiFp(configuration).analyzeMasterDownload(slug, options)(axios, basePath);
        },
        /**
         *
         * @summary 分析マスタ一覧（IF00015）
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        analyzeMasterList: function (options) {
            return AnalyzeMasterApiFp(configuration).analyzeMasterList(options)(axios, basePath);
        },
    };
};
/**
 * AnalyzeMasterApi - object-oriented interface
 * @export
 * @class AnalyzeMasterApi
 * @extends {BaseAPI}
 */
var AnalyzeMasterApi = /** @class */ (function (_super) {
    __extends(AnalyzeMasterApi, _super);
    function AnalyzeMasterApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary 分析マスタダウンロード（IF00015）
     * @param {string} slug 対象分析マスタ名
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnalyzeMasterApi
     */
    AnalyzeMasterApi.prototype.analyzeMasterDownload = function (slug, options) {
        return AnalyzeMasterApiFp(this.configuration).analyzeMasterDownload(slug, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary 分析マスタ一覧（IF00015）
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnalyzeMasterApi
     */
    AnalyzeMasterApi.prototype.analyzeMasterList = function (options) {
        return AnalyzeMasterApiFp(this.configuration).analyzeMasterList(options)(this.axios, this.basePath);
    };
    return AnalyzeMasterApi;
}(BaseAPI));
export { AnalyzeMasterApi };
/**
 * BookmarkApi - axios parameter creator
 * @export
 */
export var BookmarkApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary ブックマーク登録
         * @param {BookmarkModel} bookmarkModel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bookmarkAdd: function (bookmarkModel, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'bookmarkModel' is not null or undefined
            if (bookmarkModel === null || bookmarkModel === undefined) {
                throw new RequiredError('bookmarkModel', 'Required parameter bookmarkModel was null or undefined when calling bookmarkAdd.');
            }
            var localVarPath = "/bookmark";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'POST' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("BookmarkModel" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(bookmarkModel !== undefined ? bookmarkModel : {}) : (bookmarkModel || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary ブックマーク削除
         * @param {Array<object>} requestBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bookmarkDelete: function (requestBody, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'requestBody' is not null or undefined
            if (requestBody === null || requestBody === undefined) {
                throw new RequiredError('requestBody', 'Required parameter requestBody was null or undefined when calling bookmarkDelete.');
            }
            var localVarPath = "/bookmark";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'DELETE' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("Array&lt;object&gt;" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(requestBody !== undefined ? requestBody : {}) : (requestBody || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary ブックマーク詳細
         * @param {number} id 対象のID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bookmarkDetail: function (id, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id', 'Required parameter id was null or undefined when calling bookmarkDetail.');
            }
            var localVarPath = "/bookmark/{id}"
                .replace("{" + "id" + "}", encodeURIComponent(String(id)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary ブックマーク更新
         * @param {Bookmark} bookmark
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bookmarkEdit: function (bookmark, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'bookmark' is not null or undefined
            if (bookmark === null || bookmark === undefined) {
                throw new RequiredError('bookmark', 'Required parameter bookmark was null or undefined when calling bookmarkEdit.');
            }
            var localVarPath = "/bookmark";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'PUT' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("Bookmark" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(bookmark !== undefined ? bookmark : {}) : (bookmark || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary ブックマーク一覧
         * @param {number} [pageNo] 表示するページ数
         * @param {number} [pageSize] ページ内に表示するリストの数。0の場合は全件取得する
         * @param {string} [sortField] ソート対象名
         * @param {string} [sortType] 昇順、降順(\&quot;-\&quot;:昇順、省略時:降順)
         * @param {string} [freeword] フリーワード検索
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bookmarkList: function (pageNo, pageSize, sortField, sortType, freeword, options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/bookmark/list";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (pageNo !== undefined) {
                localVarQueryParameter['page_no'] = pageNo;
            }
            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }
            if (sortField !== undefined) {
                localVarQueryParameter['sort_field'] = sortField;
            }
            if (sortType !== undefined) {
                localVarQueryParameter['sort_type'] = sortType;
            }
            if (freeword !== undefined) {
                localVarQueryParameter['freeword'] = freeword;
            }
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * BookmarkApi - functional programming interface
 * @export
 */
export var BookmarkApiFp = function (configuration) {
    return {
        /**
         *
         * @summary ブックマーク登録
         * @param {BookmarkModel} bookmarkModel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bookmarkAdd: function (bookmarkModel, options) {
            var localVarAxiosArgs = BookmarkApiAxiosParamCreator(configuration).bookmarkAdd(bookmarkModel, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary ブックマーク削除
         * @param {Array<object>} requestBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bookmarkDelete: function (requestBody, options) {
            var localVarAxiosArgs = BookmarkApiAxiosParamCreator(configuration).bookmarkDelete(requestBody, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary ブックマーク詳細
         * @param {number} id 対象のID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bookmarkDetail: function (id, options) {
            var localVarAxiosArgs = BookmarkApiAxiosParamCreator(configuration).bookmarkDetail(id, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary ブックマーク更新
         * @param {Bookmark} bookmark
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bookmarkEdit: function (bookmark, options) {
            var localVarAxiosArgs = BookmarkApiAxiosParamCreator(configuration).bookmarkEdit(bookmark, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary ブックマーク一覧
         * @param {number} [pageNo] 表示するページ数
         * @param {number} [pageSize] ページ内に表示するリストの数。0の場合は全件取得する
         * @param {string} [sortField] ソート対象名
         * @param {string} [sortType] 昇順、降順(\&quot;-\&quot;:昇順、省略時:降順)
         * @param {string} [freeword] フリーワード検索
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bookmarkList: function (pageNo, pageSize, sortField, sortType, freeword, options) {
            var localVarAxiosArgs = BookmarkApiAxiosParamCreator(configuration).bookmarkList(pageNo, pageSize, sortField, sortType, freeword, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
    };
};
/**
 * BookmarkApi - factory interface
 * @export
 */
export var BookmarkApiFactory = function (configuration, basePath, axios) {
    return {
        /**
         *
         * @summary ブックマーク登録
         * @param {BookmarkModel} bookmarkModel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bookmarkAdd: function (bookmarkModel, options) {
            return BookmarkApiFp(configuration).bookmarkAdd(bookmarkModel, options)(axios, basePath);
        },
        /**
         *
         * @summary ブックマーク削除
         * @param {Array<object>} requestBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bookmarkDelete: function (requestBody, options) {
            return BookmarkApiFp(configuration).bookmarkDelete(requestBody, options)(axios, basePath);
        },
        /**
         *
         * @summary ブックマーク詳細
         * @param {number} id 対象のID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bookmarkDetail: function (id, options) {
            return BookmarkApiFp(configuration).bookmarkDetail(id, options)(axios, basePath);
        },
        /**
         *
         * @summary ブックマーク更新
         * @param {Bookmark} bookmark
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bookmarkEdit: function (bookmark, options) {
            return BookmarkApiFp(configuration).bookmarkEdit(bookmark, options)(axios, basePath);
        },
        /**
         *
         * @summary ブックマーク一覧
         * @param {number} [pageNo] 表示するページ数
         * @param {number} [pageSize] ページ内に表示するリストの数。0の場合は全件取得する
         * @param {string} [sortField] ソート対象名
         * @param {string} [sortType] 昇順、降順(\&quot;-\&quot;:昇順、省略時:降順)
         * @param {string} [freeword] フリーワード検索
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bookmarkList: function (pageNo, pageSize, sortField, sortType, freeword, options) {
            return BookmarkApiFp(configuration).bookmarkList(pageNo, pageSize, sortField, sortType, freeword, options)(axios, basePath);
        },
    };
};
/**
 * BookmarkApi - object-oriented interface
 * @export
 * @class BookmarkApi
 * @extends {BaseAPI}
 */
var BookmarkApi = /** @class */ (function (_super) {
    __extends(BookmarkApi, _super);
    function BookmarkApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary ブックマーク登録
     * @param {BookmarkModel} bookmarkModel
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookmarkApi
     */
    BookmarkApi.prototype.bookmarkAdd = function (bookmarkModel, options) {
        return BookmarkApiFp(this.configuration).bookmarkAdd(bookmarkModel, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary ブックマーク削除
     * @param {Array<object>} requestBody
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookmarkApi
     */
    BookmarkApi.prototype.bookmarkDelete = function (requestBody, options) {
        return BookmarkApiFp(this.configuration).bookmarkDelete(requestBody, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary ブックマーク詳細
     * @param {number} id 対象のID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookmarkApi
     */
    BookmarkApi.prototype.bookmarkDetail = function (id, options) {
        return BookmarkApiFp(this.configuration).bookmarkDetail(id, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary ブックマーク更新
     * @param {Bookmark} bookmark
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookmarkApi
     */
    BookmarkApi.prototype.bookmarkEdit = function (bookmark, options) {
        return BookmarkApiFp(this.configuration).bookmarkEdit(bookmark, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary ブックマーク一覧
     * @param {number} [pageNo] 表示するページ数
     * @param {number} [pageSize] ページ内に表示するリストの数。0の場合は全件取得する
     * @param {string} [sortField] ソート対象名
     * @param {string} [sortType] 昇順、降順(\&quot;-\&quot;:昇順、省略時:降順)
     * @param {string} [freeword] フリーワード検索
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookmarkApi
     */
    BookmarkApi.prototype.bookmarkList = function (pageNo, pageSize, sortField, sortType, freeword, options) {
        return BookmarkApiFp(this.configuration).bookmarkList(pageNo, pageSize, sortField, sortType, freeword, options)(this.axios, this.basePath);
    };
    return BookmarkApi;
}(BaseAPI));
export { BookmarkApi };
/**
 * CategoryGroupApi - axios parameter creator
 * @export
 */
export var CategoryGroupApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary カテゴリグループ登録
         * @param {CategoryGroupFormAdd} categoryGroupFormAdd
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        categoryGroupAdd: function (categoryGroupFormAdd, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'categoryGroupFormAdd' is not null or undefined
            if (categoryGroupFormAdd === null || categoryGroupFormAdd === undefined) {
                throw new RequiredError('categoryGroupFormAdd', 'Required parameter categoryGroupFormAdd was null or undefined when calling categoryGroupAdd.');
            }
            var localVarPath = "/category_group";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'POST' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("CategoryGroupFormAdd" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(categoryGroupFormAdd !== undefined ? categoryGroupFormAdd : {}) : (categoryGroupFormAdd || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary カテゴリグループ削除
         * @param {Array<object>} requestBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        categoryGroupDelete: function (requestBody, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'requestBody' is not null or undefined
            if (requestBody === null || requestBody === undefined) {
                throw new RequiredError('requestBody', 'Required parameter requestBody was null or undefined when calling categoryGroupDelete.');
            }
            var localVarPath = "/category_group";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'DELETE' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("Array&lt;object&gt;" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(requestBody !== undefined ? requestBody : {}) : (requestBody || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary カテゴリグループ詳細
         * @param {number} id 対象のID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        categoryGroupDetail: function (id, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id', 'Required parameter id was null or undefined when calling categoryGroupDetail.');
            }
            var localVarPath = "/category_group/{id}"
                .replace("{" + "id" + "}", encodeURIComponent(String(id)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary カテゴリグループダウンロード
         * @param {InlineObject2} [inlineObject2]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        categoryGroupDownload: function (inlineObject2, options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/category_group/download";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'POST' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("InlineObject2" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(inlineObject2 !== undefined ? inlineObject2 : {}) : (inlineObject2 || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary カテゴリグループ更新
         * @param {CategoryGroupFormEdit} categoryGroupFormEdit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        categoryGroupEdit: function (categoryGroupFormEdit, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'categoryGroupFormEdit' is not null or undefined
            if (categoryGroupFormEdit === null || categoryGroupFormEdit === undefined) {
                throw new RequiredError('categoryGroupFormEdit', 'Required parameter categoryGroupFormEdit was null or undefined when calling categoryGroupEdit.');
            }
            var localVarPath = "/category_group";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'PUT' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("CategoryGroupFormEdit" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(categoryGroupFormEdit !== undefined ? categoryGroupFormEdit : {}) : (categoryGroupFormEdit || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary カテゴリグループ一覧
         * @param {number} [pageNo] 表示するページ数
         * @param {number} [pageSize] ページ内に表示するリストの数。0の場合は全件取得する
         * @param {string} [sortField] ソート対象名
         * @param {string} [sortType] 昇順、降順(\&quot;-\&quot;:昇順、省略時:降順)
         * @param {string} [freeword] フリーワード検索
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        categoryGroupList: function (pageNo, pageSize, sortField, sortType, freeword, options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/category_group/list";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (pageNo !== undefined) {
                localVarQueryParameter['page_no'] = pageNo;
            }
            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }
            if (sortField !== undefined) {
                localVarQueryParameter['sort_field'] = sortField;
            }
            if (sortType !== undefined) {
                localVarQueryParameter['sort_type'] = sortType;
            }
            if (freeword !== undefined) {
                localVarQueryParameter['freeword'] = freeword;
            }
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * CategoryGroupApi - functional programming interface
 * @export
 */
export var CategoryGroupApiFp = function (configuration) {
    return {
        /**
         *
         * @summary カテゴリグループ登録
         * @param {CategoryGroupFormAdd} categoryGroupFormAdd
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        categoryGroupAdd: function (categoryGroupFormAdd, options) {
            var localVarAxiosArgs = CategoryGroupApiAxiosParamCreator(configuration).categoryGroupAdd(categoryGroupFormAdd, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary カテゴリグループ削除
         * @param {Array<object>} requestBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        categoryGroupDelete: function (requestBody, options) {
            var localVarAxiosArgs = CategoryGroupApiAxiosParamCreator(configuration).categoryGroupDelete(requestBody, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary カテゴリグループ詳細
         * @param {number} id 対象のID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        categoryGroupDetail: function (id, options) {
            var localVarAxiosArgs = CategoryGroupApiAxiosParamCreator(configuration).categoryGroupDetail(id, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary カテゴリグループダウンロード
         * @param {InlineObject2} [inlineObject2]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        categoryGroupDownload: function (inlineObject2, options) {
            var localVarAxiosArgs = CategoryGroupApiAxiosParamCreator(configuration).categoryGroupDownload(inlineObject2, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary カテゴリグループ更新
         * @param {CategoryGroupFormEdit} categoryGroupFormEdit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        categoryGroupEdit: function (categoryGroupFormEdit, options) {
            var localVarAxiosArgs = CategoryGroupApiAxiosParamCreator(configuration).categoryGroupEdit(categoryGroupFormEdit, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary カテゴリグループ一覧
         * @param {number} [pageNo] 表示するページ数
         * @param {number} [pageSize] ページ内に表示するリストの数。0の場合は全件取得する
         * @param {string} [sortField] ソート対象名
         * @param {string} [sortType] 昇順、降順(\&quot;-\&quot;:昇順、省略時:降順)
         * @param {string} [freeword] フリーワード検索
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        categoryGroupList: function (pageNo, pageSize, sortField, sortType, freeword, options) {
            var localVarAxiosArgs = CategoryGroupApiAxiosParamCreator(configuration).categoryGroupList(pageNo, pageSize, sortField, sortType, freeword, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
    };
};
/**
 * CategoryGroupApi - factory interface
 * @export
 */
export var CategoryGroupApiFactory = function (configuration, basePath, axios) {
    return {
        /**
         *
         * @summary カテゴリグループ登録
         * @param {CategoryGroupFormAdd} categoryGroupFormAdd
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        categoryGroupAdd: function (categoryGroupFormAdd, options) {
            return CategoryGroupApiFp(configuration).categoryGroupAdd(categoryGroupFormAdd, options)(axios, basePath);
        },
        /**
         *
         * @summary カテゴリグループ削除
         * @param {Array<object>} requestBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        categoryGroupDelete: function (requestBody, options) {
            return CategoryGroupApiFp(configuration).categoryGroupDelete(requestBody, options)(axios, basePath);
        },
        /**
         *
         * @summary カテゴリグループ詳細
         * @param {number} id 対象のID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        categoryGroupDetail: function (id, options) {
            return CategoryGroupApiFp(configuration).categoryGroupDetail(id, options)(axios, basePath);
        },
        /**
         *
         * @summary カテゴリグループダウンロード
         * @param {InlineObject2} [inlineObject2]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        categoryGroupDownload: function (inlineObject2, options) {
            return CategoryGroupApiFp(configuration).categoryGroupDownload(inlineObject2, options)(axios, basePath);
        },
        /**
         *
         * @summary カテゴリグループ更新
         * @param {CategoryGroupFormEdit} categoryGroupFormEdit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        categoryGroupEdit: function (categoryGroupFormEdit, options) {
            return CategoryGroupApiFp(configuration).categoryGroupEdit(categoryGroupFormEdit, options)(axios, basePath);
        },
        /**
         *
         * @summary カテゴリグループ一覧
         * @param {number} [pageNo] 表示するページ数
         * @param {number} [pageSize] ページ内に表示するリストの数。0の場合は全件取得する
         * @param {string} [sortField] ソート対象名
         * @param {string} [sortType] 昇順、降順(\&quot;-\&quot;:昇順、省略時:降順)
         * @param {string} [freeword] フリーワード検索
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        categoryGroupList: function (pageNo, pageSize, sortField, sortType, freeword, options) {
            return CategoryGroupApiFp(configuration).categoryGroupList(pageNo, pageSize, sortField, sortType, freeword, options)(axios, basePath);
        },
    };
};
/**
 * CategoryGroupApi - object-oriented interface
 * @export
 * @class CategoryGroupApi
 * @extends {BaseAPI}
 */
var CategoryGroupApi = /** @class */ (function (_super) {
    __extends(CategoryGroupApi, _super);
    function CategoryGroupApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary カテゴリグループ登録
     * @param {CategoryGroupFormAdd} categoryGroupFormAdd
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CategoryGroupApi
     */
    CategoryGroupApi.prototype.categoryGroupAdd = function (categoryGroupFormAdd, options) {
        return CategoryGroupApiFp(this.configuration).categoryGroupAdd(categoryGroupFormAdd, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary カテゴリグループ削除
     * @param {Array<object>} requestBody
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CategoryGroupApi
     */
    CategoryGroupApi.prototype.categoryGroupDelete = function (requestBody, options) {
        return CategoryGroupApiFp(this.configuration).categoryGroupDelete(requestBody, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary カテゴリグループ詳細
     * @param {number} id 対象のID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CategoryGroupApi
     */
    CategoryGroupApi.prototype.categoryGroupDetail = function (id, options) {
        return CategoryGroupApiFp(this.configuration).categoryGroupDetail(id, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary カテゴリグループダウンロード
     * @param {InlineObject2} [inlineObject2]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CategoryGroupApi
     */
    CategoryGroupApi.prototype.categoryGroupDownload = function (inlineObject2, options) {
        return CategoryGroupApiFp(this.configuration).categoryGroupDownload(inlineObject2, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary カテゴリグループ更新
     * @param {CategoryGroupFormEdit} categoryGroupFormEdit
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CategoryGroupApi
     */
    CategoryGroupApi.prototype.categoryGroupEdit = function (categoryGroupFormEdit, options) {
        return CategoryGroupApiFp(this.configuration).categoryGroupEdit(categoryGroupFormEdit, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary カテゴリグループ一覧
     * @param {number} [pageNo] 表示するページ数
     * @param {number} [pageSize] ページ内に表示するリストの数。0の場合は全件取得する
     * @param {string} [sortField] ソート対象名
     * @param {string} [sortType] 昇順、降順(\&quot;-\&quot;:昇順、省略時:降順)
     * @param {string} [freeword] フリーワード検索
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CategoryGroupApi
     */
    CategoryGroupApi.prototype.categoryGroupList = function (pageNo, pageSize, sortField, sortType, freeword, options) {
        return CategoryGroupApiFp(this.configuration).categoryGroupList(pageNo, pageSize, sortField, sortType, freeword, options)(this.axios, this.basePath);
    };
    return CategoryGroupApi;
}(BaseAPI));
export { CategoryGroupApi };
/**
 * ContractApi - axios parameter creator
 * @export
 */
export var ContractApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary 企業登録
         * @param {ContractFormAddModel} contractFormAddModel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        contractAdd: function (contractFormAddModel, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'contractFormAddModel' is not null or undefined
            if (contractFormAddModel === null || contractFormAddModel === undefined) {
                throw new RequiredError('contractFormAddModel', 'Required parameter contractFormAddModel was null or undefined when calling contractAdd.');
            }
            var localVarPath = "/contract";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'POST' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("ContractFormAddModel" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(contractFormAddModel !== undefined ? contractFormAddModel : {}) : (contractFormAddModel || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 企業削除
         * @param {Array<object>} requestBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        contractDelete: function (requestBody, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'requestBody' is not null or undefined
            if (requestBody === null || requestBody === undefined) {
                throw new RequiredError('requestBody', 'Required parameter requestBody was null or undefined when calling contractDelete.');
            }
            var localVarPath = "/contract";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'DELETE' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("Array&lt;object&gt;" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(requestBody !== undefined ? requestBody : {}) : (requestBody || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 企業詳細
         * @param {number} id 対象のID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        contractDetail: function (id, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id', 'Required parameter id was null or undefined when calling contractDetail.');
            }
            var localVarPath = "/contract/{id}"
                .replace("{" + "id" + "}", encodeURIComponent(String(id)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 企業更新
         * @param {ContractFormEditModel} contractFormEditModel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        contractEdit: function (contractFormEditModel, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'contractFormEditModel' is not null or undefined
            if (contractFormEditModel === null || contractFormEditModel === undefined) {
                throw new RequiredError('contractFormEditModel', 'Required parameter contractFormEditModel was null or undefined when calling contractEdit.');
            }
            var localVarPath = "/contract";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'PUT' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("ContractFormEditModel" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(contractFormEditModel !== undefined ? contractFormEditModel : {}) : (contractFormEditModel || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 企業一覧
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        contractList: function (options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/contract/list";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 企業一覧（管理画面リスト用）
         * @param {number} isActive 1:終了した契約も含む
         * @param {number} [pageNo] 表示するページ数
         * @param {number} [pageSize] ページ内に表示するリストの数。0の場合は全件取得する
         * @param {string} [sortField] ソート対象名
         * @param {string} [sortType] 昇順、降順(\&quot;-\&quot;:昇順、省略時:降順)
         * @param {string} [freeword] フリーワード検索
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        contractListAdmin: function (isActive, pageNo, pageSize, sortField, sortType, freeword, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'isActive' is not null or undefined
            if (isActive === null || isActive === undefined) {
                throw new RequiredError('isActive', 'Required parameter isActive was null or undefined when calling contractListAdmin.');
            }
            var localVarPath = "/contract/list_admin";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (pageNo !== undefined) {
                localVarQueryParameter['page_no'] = pageNo;
            }
            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }
            if (sortField !== undefined) {
                localVarQueryParameter['sort_field'] = sortField;
            }
            if (sortType !== undefined) {
                localVarQueryParameter['sort_type'] = sortType;
            }
            if (freeword !== undefined) {
                localVarQueryParameter['freeword'] = freeword;
            }
            if (isActive !== undefined) {
                localVarQueryParameter['is_active'] = isActive;
            }
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * ContractApi - functional programming interface
 * @export
 */
export var ContractApiFp = function (configuration) {
    return {
        /**
         *
         * @summary 企業登録
         * @param {ContractFormAddModel} contractFormAddModel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        contractAdd: function (contractFormAddModel, options) {
            var localVarAxiosArgs = ContractApiAxiosParamCreator(configuration).contractAdd(contractFormAddModel, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary 企業削除
         * @param {Array<object>} requestBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        contractDelete: function (requestBody, options) {
            var localVarAxiosArgs = ContractApiAxiosParamCreator(configuration).contractDelete(requestBody, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary 企業詳細
         * @param {number} id 対象のID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        contractDetail: function (id, options) {
            var localVarAxiosArgs = ContractApiAxiosParamCreator(configuration).contractDetail(id, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary 企業更新
         * @param {ContractFormEditModel} contractFormEditModel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        contractEdit: function (contractFormEditModel, options) {
            var localVarAxiosArgs = ContractApiAxiosParamCreator(configuration).contractEdit(contractFormEditModel, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary 企業一覧
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        contractList: function (options) {
            var localVarAxiosArgs = ContractApiAxiosParamCreator(configuration).contractList(options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary 企業一覧（管理画面リスト用）
         * @param {number} isActive 1:終了した契約も含む
         * @param {number} [pageNo] 表示するページ数
         * @param {number} [pageSize] ページ内に表示するリストの数。0の場合は全件取得する
         * @param {string} [sortField] ソート対象名
         * @param {string} [sortType] 昇順、降順(\&quot;-\&quot;:昇順、省略時:降順)
         * @param {string} [freeword] フリーワード検索
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        contractListAdmin: function (isActive, pageNo, pageSize, sortField, sortType, freeword, options) {
            var localVarAxiosArgs = ContractApiAxiosParamCreator(configuration).contractListAdmin(isActive, pageNo, pageSize, sortField, sortType, freeword, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
    };
};
/**
 * ContractApi - factory interface
 * @export
 */
export var ContractApiFactory = function (configuration, basePath, axios) {
    return {
        /**
         *
         * @summary 企業登録
         * @param {ContractFormAddModel} contractFormAddModel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        contractAdd: function (contractFormAddModel, options) {
            return ContractApiFp(configuration).contractAdd(contractFormAddModel, options)(axios, basePath);
        },
        /**
         *
         * @summary 企業削除
         * @param {Array<object>} requestBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        contractDelete: function (requestBody, options) {
            return ContractApiFp(configuration).contractDelete(requestBody, options)(axios, basePath);
        },
        /**
         *
         * @summary 企業詳細
         * @param {number} id 対象のID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        contractDetail: function (id, options) {
            return ContractApiFp(configuration).contractDetail(id, options)(axios, basePath);
        },
        /**
         *
         * @summary 企業更新
         * @param {ContractFormEditModel} contractFormEditModel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        contractEdit: function (contractFormEditModel, options) {
            return ContractApiFp(configuration).contractEdit(contractFormEditModel, options)(axios, basePath);
        },
        /**
         *
         * @summary 企業一覧
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        contractList: function (options) {
            return ContractApiFp(configuration).contractList(options)(axios, basePath);
        },
        /**
         *
         * @summary 企業一覧（管理画面リスト用）
         * @param {number} isActive 1:終了した契約も含む
         * @param {number} [pageNo] 表示するページ数
         * @param {number} [pageSize] ページ内に表示するリストの数。0の場合は全件取得する
         * @param {string} [sortField] ソート対象名
         * @param {string} [sortType] 昇順、降順(\&quot;-\&quot;:昇順、省略時:降順)
         * @param {string} [freeword] フリーワード検索
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        contractListAdmin: function (isActive, pageNo, pageSize, sortField, sortType, freeword, options) {
            return ContractApiFp(configuration).contractListAdmin(isActive, pageNo, pageSize, sortField, sortType, freeword, options)(axios, basePath);
        },
    };
};
/**
 * ContractApi - object-oriented interface
 * @export
 * @class ContractApi
 * @extends {BaseAPI}
 */
var ContractApi = /** @class */ (function (_super) {
    __extends(ContractApi, _super);
    function ContractApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary 企業登録
     * @param {ContractFormAddModel} contractFormAddModel
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContractApi
     */
    ContractApi.prototype.contractAdd = function (contractFormAddModel, options) {
        return ContractApiFp(this.configuration).contractAdd(contractFormAddModel, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary 企業削除
     * @param {Array<object>} requestBody
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContractApi
     */
    ContractApi.prototype.contractDelete = function (requestBody, options) {
        return ContractApiFp(this.configuration).contractDelete(requestBody, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary 企業詳細
     * @param {number} id 対象のID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContractApi
     */
    ContractApi.prototype.contractDetail = function (id, options) {
        return ContractApiFp(this.configuration).contractDetail(id, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary 企業更新
     * @param {ContractFormEditModel} contractFormEditModel
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContractApi
     */
    ContractApi.prototype.contractEdit = function (contractFormEditModel, options) {
        return ContractApiFp(this.configuration).contractEdit(contractFormEditModel, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary 企業一覧
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContractApi
     */
    ContractApi.prototype.contractList = function (options) {
        return ContractApiFp(this.configuration).contractList(options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary 企業一覧（管理画面リスト用）
     * @param {number} isActive 1:終了した契約も含む
     * @param {number} [pageNo] 表示するページ数
     * @param {number} [pageSize] ページ内に表示するリストの数。0の場合は全件取得する
     * @param {string} [sortField] ソート対象名
     * @param {string} [sortType] 昇順、降順(\&quot;-\&quot;:昇順、省略時:降順)
     * @param {string} [freeword] フリーワード検索
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContractApi
     */
    ContractApi.prototype.contractListAdmin = function (isActive, pageNo, pageSize, sortField, sortType, freeword, options) {
        return ContractApiFp(this.configuration).contractListAdmin(isActive, pageNo, pageSize, sortField, sortType, freeword, options)(this.axios, this.basePath);
    };
    return ContractApi;
}(BaseAPI));
export { ContractApi };
/**
 * DashboardApi - axios parameter creator
 * @export
 */
export var DashboardApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary ダッシュボードのマイレポート、企業レポートを返却する
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dashboard: function (options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/dashboard/init";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary ダッシュボードのレポート表示順を設定する
         * @param {ViewOrder} [viewOrder] ダッシュボードのレポート表示順を設定する
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dashboardViewOrder: function (viewOrder, options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/dashboard/view_order";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'PUT' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("ViewOrder" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(viewOrder !== undefined ? viewOrder : {}) : (viewOrder || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * DashboardApi - functional programming interface
 * @export
 */
export var DashboardApiFp = function (configuration) {
    return {
        /**
         *
         * @summary ダッシュボードのマイレポート、企業レポートを返却する
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dashboard: function (options) {
            var localVarAxiosArgs = DashboardApiAxiosParamCreator(configuration).dashboard(options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary ダッシュボードのレポート表示順を設定する
         * @param {ViewOrder} [viewOrder] ダッシュボードのレポート表示順を設定する
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dashboardViewOrder: function (viewOrder, options) {
            var localVarAxiosArgs = DashboardApiAxiosParamCreator(configuration).dashboardViewOrder(viewOrder, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
    };
};
/**
 * DashboardApi - factory interface
 * @export
 */
export var DashboardApiFactory = function (configuration, basePath, axios) {
    return {
        /**
         *
         * @summary ダッシュボードのマイレポート、企業レポートを返却する
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dashboard: function (options) {
            return DashboardApiFp(configuration).dashboard(options)(axios, basePath);
        },
        /**
         *
         * @summary ダッシュボードのレポート表示順を設定する
         * @param {ViewOrder} [viewOrder] ダッシュボードのレポート表示順を設定する
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dashboardViewOrder: function (viewOrder, options) {
            return DashboardApiFp(configuration).dashboardViewOrder(viewOrder, options)(axios, basePath);
        },
    };
};
/**
 * DashboardApi - object-oriented interface
 * @export
 * @class DashboardApi
 * @extends {BaseAPI}
 */
var DashboardApi = /** @class */ (function (_super) {
    __extends(DashboardApi, _super);
    function DashboardApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary ダッシュボードのマイレポート、企業レポートを返却する
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardApi
     */
    DashboardApi.prototype.dashboard = function (options) {
        return DashboardApiFp(this.configuration).dashboard(options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary ダッシュボードのレポート表示順を設定する
     * @param {ViewOrder} [viewOrder] ダッシュボードのレポート表示順を設定する
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardApi
     */
    DashboardApi.prototype.dashboardViewOrder = function (viewOrder, options) {
        return DashboardApiFp(this.configuration).dashboardViewOrder(viewOrder, options)(this.axios, this.basePath);
    };
    return DashboardApi;
}(BaseAPI));
export { DashboardApi };
/**
 * DepartmentApi - axios parameter creator
 * @export
 */
export var DepartmentApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary 所属一覧
         * @param {number} contractId 対象の企業ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        departmentList: function (contractId, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'contractId' is not null or undefined
            if (contractId === null || contractId === undefined) {
                throw new RequiredError('contractId', 'Required parameter contractId was null or undefined when calling departmentList.');
            }
            var localVarPath = "/department/list/{contract_id}"
                .replace("{" + "contract_id" + "}", encodeURIComponent(String(contractId)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * DepartmentApi - functional programming interface
 * @export
 */
export var DepartmentApiFp = function (configuration) {
    return {
        /**
         *
         * @summary 所属一覧
         * @param {number} contractId 対象の企業ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        departmentList: function (contractId, options) {
            var localVarAxiosArgs = DepartmentApiAxiosParamCreator(configuration).departmentList(contractId, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
    };
};
/**
 * DepartmentApi - factory interface
 * @export
 */
export var DepartmentApiFactory = function (configuration, basePath, axios) {
    return {
        /**
         *
         * @summary 所属一覧
         * @param {number} contractId 対象の企業ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        departmentList: function (contractId, options) {
            return DepartmentApiFp(configuration).departmentList(contractId, options)(axios, basePath);
        },
    };
};
/**
 * DepartmentApi - object-oriented interface
 * @export
 * @class DepartmentApi
 * @extends {BaseAPI}
 */
var DepartmentApi = /** @class */ (function (_super) {
    __extends(DepartmentApi, _super);
    function DepartmentApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary 所属一覧
     * @param {number} contractId 対象の企業ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DepartmentApi
     */
    DepartmentApi.prototype.departmentList = function (contractId, options) {
        return DepartmentApiFp(this.configuration).departmentList(contractId, options)(this.axios, this.basePath);
    };
    return DepartmentApi;
}(BaseAPI));
export { DepartmentApi };
/**
 * HistoryApi - axios parameter creator
 * @export
 */
export var HistoryApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary 分析履歴削除
         * @param {Array<object>} requestBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        historyDelete: function (requestBody, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'requestBody' is not null or undefined
            if (requestBody === null || requestBody === undefined) {
                throw new RequiredError('requestBody', 'Required parameter requestBody was null or undefined when calling historyDelete.');
            }
            var localVarPath = "/history";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'DELETE' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("Array&lt;object&gt;" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(requestBody !== undefined ? requestBody : {}) : (requestBody || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 分析履歴詳細
         * @param {number} id 対象のID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        historyDetail: function (id, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id', 'Required parameter id was null or undefined when calling historyDetail.');
            }
            var localVarPath = "/history/{id}"
                .replace("{" + "id" + "}", encodeURIComponent(String(id)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 分析履歴更新
         * @param {HistoryEditModel} historyEditModel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        historyEdit: function (historyEditModel, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'historyEditModel' is not null or undefined
            if (historyEditModel === null || historyEditModel === undefined) {
                throw new RequiredError('historyEditModel', 'Required parameter historyEditModel was null or undefined when calling historyEdit.');
            }
            var localVarPath = "/history";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'PUT' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("HistoryEditModel" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(historyEditModel !== undefined ? historyEditModel : {}) : (historyEditModel || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 分析履歴一覧
         * @param {number} [pageNo] 表示するページ数
         * @param {number} [pageSize] ページ内に表示するリストの数。0の場合は全件取得する
         * @param {string} [sortField] ソート対象名
         * @param {string} [sortType] 昇順、降順(\&quot;-\&quot;:昇順、省略時:降順)
         * @param {string} [freeword] フリーワード検索
         * @param {number} [userId] 履歴作成者ID
         * @param {string} [analyzeTargetCode] 分析ID
         * @param {string} [publishSetting]
         * @param {string} [analyzeType]
         * @param {string} [analyzeTermFrom]
         * @param {string} [analyzeTermTo]
         * @param {string} [readStatus]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        historyList: function (pageNo, pageSize, sortField, sortType, freeword, userId, analyzeTargetCode, publishSetting, analyzeType, analyzeTermFrom, analyzeTermTo, readStatus, options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/history/list";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (pageNo !== undefined) {
                localVarQueryParameter['page_no'] = pageNo;
            }
            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }
            if (sortField !== undefined) {
                localVarQueryParameter['sort_field'] = sortField;
            }
            if (sortType !== undefined) {
                localVarQueryParameter['sort_type'] = sortType;
            }
            if (freeword !== undefined) {
                localVarQueryParameter['freeword'] = freeword;
            }
            if (userId !== undefined) {
                localVarQueryParameter['user_id'] = userId;
            }
            if (analyzeTargetCode !== undefined) {
                localVarQueryParameter['analyze_target_code'] = analyzeTargetCode;
            }
            if (publishSetting !== undefined) {
                localVarQueryParameter['publish_setting'] = publishSetting;
            }
            if (analyzeType !== undefined) {
                localVarQueryParameter['analyze_type'] = analyzeType;
            }
            if (analyzeTermFrom !== undefined) {
                localVarQueryParameter['analyze_term_from'] = analyzeTermFrom;
            }
            if (analyzeTermTo !== undefined) {
                localVarQueryParameter['analyze_term_to'] = analyzeTermTo;
            }
            if (readStatus !== undefined) {
                localVarQueryParameter['read_status'] = readStatus;
            }
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 分析履歴用ユーザ一覧
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        historyUserList: function (options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/history/user_list";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * HistoryApi - functional programming interface
 * @export
 */
export var HistoryApiFp = function (configuration) {
    return {
        /**
         *
         * @summary 分析履歴削除
         * @param {Array<object>} requestBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        historyDelete: function (requestBody, options) {
            var localVarAxiosArgs = HistoryApiAxiosParamCreator(configuration).historyDelete(requestBody, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary 分析履歴詳細
         * @param {number} id 対象のID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        historyDetail: function (id, options) {
            var localVarAxiosArgs = HistoryApiAxiosParamCreator(configuration).historyDetail(id, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary 分析履歴更新
         * @param {HistoryEditModel} historyEditModel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        historyEdit: function (historyEditModel, options) {
            var localVarAxiosArgs = HistoryApiAxiosParamCreator(configuration).historyEdit(historyEditModel, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary 分析履歴一覧
         * @param {number} [pageNo] 表示するページ数
         * @param {number} [pageSize] ページ内に表示するリストの数。0の場合は全件取得する
         * @param {string} [sortField] ソート対象名
         * @param {string} [sortType] 昇順、降順(\&quot;-\&quot;:昇順、省略時:降順)
         * @param {string} [freeword] フリーワード検索
         * @param {number} [userId] 履歴作成者ID
         * @param {string} [analyzeTargetCode] 分析ID
         * @param {string} [publishSetting]
         * @param {string} [analyzeType]
         * @param {string} [analyzeTermFrom]
         * @param {string} [analyzeTermTo]
         * @param {string} [readStatus]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        historyList: function (pageNo, pageSize, sortField, sortType, freeword, userId, analyzeTargetCode, publishSetting, analyzeType, analyzeTermFrom, analyzeTermTo, readStatus, options) {
            var localVarAxiosArgs = HistoryApiAxiosParamCreator(configuration).historyList(pageNo, pageSize, sortField, sortType, freeword, userId, analyzeTargetCode, publishSetting, analyzeType, analyzeTermFrom, analyzeTermTo, readStatus, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary 分析履歴用ユーザ一覧
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        historyUserList: function (options) {
            var localVarAxiosArgs = HistoryApiAxiosParamCreator(configuration).historyUserList(options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
    };
};
/**
 * HistoryApi - factory interface
 * @export
 */
export var HistoryApiFactory = function (configuration, basePath, axios) {
    return {
        /**
         *
         * @summary 分析履歴削除
         * @param {Array<object>} requestBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        historyDelete: function (requestBody, options) {
            return HistoryApiFp(configuration).historyDelete(requestBody, options)(axios, basePath);
        },
        /**
         *
         * @summary 分析履歴詳細
         * @param {number} id 対象のID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        historyDetail: function (id, options) {
            return HistoryApiFp(configuration).historyDetail(id, options)(axios, basePath);
        },
        /**
         *
         * @summary 分析履歴更新
         * @param {HistoryEditModel} historyEditModel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        historyEdit: function (historyEditModel, options) {
            return HistoryApiFp(configuration).historyEdit(historyEditModel, options)(axios, basePath);
        },
        /**
         *
         * @summary 分析履歴一覧
         * @param {number} [pageNo] 表示するページ数
         * @param {number} [pageSize] ページ内に表示するリストの数。0の場合は全件取得する
         * @param {string} [sortField] ソート対象名
         * @param {string} [sortType] 昇順、降順(\&quot;-\&quot;:昇順、省略時:降順)
         * @param {string} [freeword] フリーワード検索
         * @param {number} [userId] 履歴作成者ID
         * @param {string} [analyzeTargetCode] 分析ID
         * @param {string} [publishSetting]
         * @param {string} [analyzeType]
         * @param {string} [analyzeTermFrom]
         * @param {string} [analyzeTermTo]
         * @param {string} [readStatus]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        historyList: function (pageNo, pageSize, sortField, sortType, freeword, userId, analyzeTargetCode, publishSetting, analyzeType, analyzeTermFrom, analyzeTermTo, readStatus, options) {
            return HistoryApiFp(configuration).historyList(pageNo, pageSize, sortField, sortType, freeword, userId, analyzeTargetCode, publishSetting, analyzeType, analyzeTermFrom, analyzeTermTo, readStatus, options)(axios, basePath);
        },
        /**
         *
         * @summary 分析履歴用ユーザ一覧
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        historyUserList: function (options) {
            return HistoryApiFp(configuration).historyUserList(options)(axios, basePath);
        },
    };
};
/**
 * HistoryApi - object-oriented interface
 * @export
 * @class HistoryApi
 * @extends {BaseAPI}
 */
var HistoryApi = /** @class */ (function (_super) {
    __extends(HistoryApi, _super);
    function HistoryApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary 分析履歴削除
     * @param {Array<object>} requestBody
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HistoryApi
     */
    HistoryApi.prototype.historyDelete = function (requestBody, options) {
        return HistoryApiFp(this.configuration).historyDelete(requestBody, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary 分析履歴詳細
     * @param {number} id 対象のID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HistoryApi
     */
    HistoryApi.prototype.historyDetail = function (id, options) {
        return HistoryApiFp(this.configuration).historyDetail(id, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary 分析履歴更新
     * @param {HistoryEditModel} historyEditModel
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HistoryApi
     */
    HistoryApi.prototype.historyEdit = function (historyEditModel, options) {
        return HistoryApiFp(this.configuration).historyEdit(historyEditModel, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary 分析履歴一覧
     * @param {number} [pageNo] 表示するページ数
     * @param {number} [pageSize] ページ内に表示するリストの数。0の場合は全件取得する
     * @param {string} [sortField] ソート対象名
     * @param {string} [sortType] 昇順、降順(\&quot;-\&quot;:昇順、省略時:降順)
     * @param {string} [freeword] フリーワード検索
     * @param {number} [userId] 履歴作成者ID
     * @param {string} [analyzeTargetCode] 分析ID
     * @param {string} [publishSetting]
     * @param {string} [analyzeType]
     * @param {string} [analyzeTermFrom]
     * @param {string} [analyzeTermTo]
     * @param {string} [readStatus]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HistoryApi
     */
    HistoryApi.prototype.historyList = function (pageNo, pageSize, sortField, sortType, freeword, userId, analyzeTargetCode, publishSetting, analyzeType, analyzeTermFrom, analyzeTermTo, readStatus, options) {
        return HistoryApiFp(this.configuration).historyList(pageNo, pageSize, sortField, sortType, freeword, userId, analyzeTargetCode, publishSetting, analyzeType, analyzeTermFrom, analyzeTermTo, readStatus, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary 分析履歴用ユーザ一覧
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HistoryApi
     */
    HistoryApi.prototype.historyUserList = function (options) {
        return HistoryApiFp(this.configuration).historyUserList(options)(this.axios, this.basePath);
    };
    return HistoryApi;
}(BaseAPI));
export { HistoryApi };
/**
 * ItemSearchApi - axios parameter creator
 * @export
 */
export var ItemSearchApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary 商品取得（商品カテゴリ）
         * @param {InlineObject23} [inlineObject23]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        itemSearchCategory: function (inlineObject23, options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/item_search/category";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'POST' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("InlineObject23" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(inlineObject23 !== undefined ? inlineObject23 : {}) : (inlineObject23 || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 商品取得（カテゴリーグループ）
         * @param {InlineObject24} [inlineObject24]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        itemSearchCategoryGroup: function (inlineObject24, options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/item_search/category_group";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'POST' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("InlineObject24" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(inlineObject24 !== undefined ? inlineObject24 : {}) : (inlineObject24 || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 商品取得（コード）
         * @param {InlineObject25} [inlineObject25]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        itemSearchCode: function (inlineObject25, options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/item_search/code";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'POST' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("InlineObject25" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(inlineObject25 !== undefined ? inlineObject25 : {}) : (inlineObject25 || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 商品取得（商品コードファイルアップロード）
         * @param {any} [file]
         * @param {string} [analyzeTargetCode]
         * @param {number} [contractFlag] 1:自社商品から選択 2:契約カテゴリーから選択 3:対象商品検索
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        itemSearchFile: function (file, analyzeTargetCode, contractFlag, options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/item_search/file";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'POST' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            var localVarFormParams = new FormData();
            if (file !== undefined) {
                localVarFormParams.append('file', file);
            }
            if (analyzeTargetCode !== undefined) {
                localVarFormParams.append('analyze_target_code', analyzeTargetCode);
            }
            if (contractFlag !== undefined) {
                localVarFormParams.append('contract_flag', contractFlag);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            localVarRequestOptions.data = localVarFormParams;
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 商品取得（フリーワード）
         * @param {InlineObject27} [inlineObject27]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        itemSearchFreeword: function (inlineObject27, options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/item_search/freeword";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'POST' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("InlineObject27" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(inlineObject27 !== undefined ? inlineObject27 : {}) : (inlineObject27 || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 商品取得（グループ）
         * @param {InlineObject28} [inlineObject28]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        itemSearchGroup: function (inlineObject28, options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/item_search/group";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'POST' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("InlineObject28" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(inlineObject28 !== undefined ? inlineObject28 : {}) : (inlineObject28 || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * ItemSearchApi - functional programming interface
 * @export
 */
export var ItemSearchApiFp = function (configuration) {
    return {
        /**
         *
         * @summary 商品取得（商品カテゴリ）
         * @param {InlineObject23} [inlineObject23]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        itemSearchCategory: function (inlineObject23, options) {
            var localVarAxiosArgs = ItemSearchApiAxiosParamCreator(configuration).itemSearchCategory(inlineObject23, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary 商品取得（カテゴリーグループ）
         * @param {InlineObject24} [inlineObject24]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        itemSearchCategoryGroup: function (inlineObject24, options) {
            var localVarAxiosArgs = ItemSearchApiAxiosParamCreator(configuration).itemSearchCategoryGroup(inlineObject24, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary 商品取得（コード）
         * @param {InlineObject25} [inlineObject25]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        itemSearchCode: function (inlineObject25, options) {
            var localVarAxiosArgs = ItemSearchApiAxiosParamCreator(configuration).itemSearchCode(inlineObject25, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary 商品取得（商品コードファイルアップロード）
         * @param {any} [file]
         * @param {string} [analyzeTargetCode]
         * @param {number} [contractFlag] 1:自社商品から選択 2:契約カテゴリーから選択 3:対象商品検索
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        itemSearchFile: function (file, analyzeTargetCode, contractFlag, options) {
            var localVarAxiosArgs = ItemSearchApiAxiosParamCreator(configuration).itemSearchFile(file, analyzeTargetCode, contractFlag, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary 商品取得（フリーワード）
         * @param {InlineObject27} [inlineObject27]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        itemSearchFreeword: function (inlineObject27, options) {
            var localVarAxiosArgs = ItemSearchApiAxiosParamCreator(configuration).itemSearchFreeword(inlineObject27, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary 商品取得（グループ）
         * @param {InlineObject28} [inlineObject28]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        itemSearchGroup: function (inlineObject28, options) {
            var localVarAxiosArgs = ItemSearchApiAxiosParamCreator(configuration).itemSearchGroup(inlineObject28, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
    };
};
/**
 * ItemSearchApi - factory interface
 * @export
 */
export var ItemSearchApiFactory = function (configuration, basePath, axios) {
    return {
        /**
         *
         * @summary 商品取得（商品カテゴリ）
         * @param {InlineObject23} [inlineObject23]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        itemSearchCategory: function (inlineObject23, options) {
            return ItemSearchApiFp(configuration).itemSearchCategory(inlineObject23, options)(axios, basePath);
        },
        /**
         *
         * @summary 商品取得（カテゴリーグループ）
         * @param {InlineObject24} [inlineObject24]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        itemSearchCategoryGroup: function (inlineObject24, options) {
            return ItemSearchApiFp(configuration).itemSearchCategoryGroup(inlineObject24, options)(axios, basePath);
        },
        /**
         *
         * @summary 商品取得（コード）
         * @param {InlineObject25} [inlineObject25]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        itemSearchCode: function (inlineObject25, options) {
            return ItemSearchApiFp(configuration).itemSearchCode(inlineObject25, options)(axios, basePath);
        },
        /**
         *
         * @summary 商品取得（商品コードファイルアップロード）
         * @param {any} [file]
         * @param {string} [analyzeTargetCode]
         * @param {number} [contractFlag] 1:自社商品から選択 2:契約カテゴリーから選択 3:対象商品検索
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        itemSearchFile: function (file, analyzeTargetCode, contractFlag, options) {
            return ItemSearchApiFp(configuration).itemSearchFile(file, analyzeTargetCode, contractFlag, options)(axios, basePath);
        },
        /**
         *
         * @summary 商品取得（フリーワード）
         * @param {InlineObject27} [inlineObject27]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        itemSearchFreeword: function (inlineObject27, options) {
            return ItemSearchApiFp(configuration).itemSearchFreeword(inlineObject27, options)(axios, basePath);
        },
        /**
         *
         * @summary 商品取得（グループ）
         * @param {InlineObject28} [inlineObject28]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        itemSearchGroup: function (inlineObject28, options) {
            return ItemSearchApiFp(configuration).itemSearchGroup(inlineObject28, options)(axios, basePath);
        },
    };
};
/**
 * ItemSearchApi - object-oriented interface
 * @export
 * @class ItemSearchApi
 * @extends {BaseAPI}
 */
var ItemSearchApi = /** @class */ (function (_super) {
    __extends(ItemSearchApi, _super);
    function ItemSearchApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary 商品取得（商品カテゴリ）
     * @param {InlineObject23} [inlineObject23]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ItemSearchApi
     */
    ItemSearchApi.prototype.itemSearchCategory = function (inlineObject23, options) {
        return ItemSearchApiFp(this.configuration).itemSearchCategory(inlineObject23, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary 商品取得（カテゴリーグループ）
     * @param {InlineObject24} [inlineObject24]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ItemSearchApi
     */
    ItemSearchApi.prototype.itemSearchCategoryGroup = function (inlineObject24, options) {
        return ItemSearchApiFp(this.configuration).itemSearchCategoryGroup(inlineObject24, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary 商品取得（コード）
     * @param {InlineObject25} [inlineObject25]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ItemSearchApi
     */
    ItemSearchApi.prototype.itemSearchCode = function (inlineObject25, options) {
        return ItemSearchApiFp(this.configuration).itemSearchCode(inlineObject25, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary 商品取得（商品コードファイルアップロード）
     * @param {any} [file]
     * @param {string} [analyzeTargetCode]
     * @param {number} [contractFlag] 1:自社商品から選択 2:契約カテゴリーから選択 3:対象商品検索
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ItemSearchApi
     */
    ItemSearchApi.prototype.itemSearchFile = function (file, analyzeTargetCode, contractFlag, options) {
        return ItemSearchApiFp(this.configuration).itemSearchFile(file, analyzeTargetCode, contractFlag, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary 商品取得（フリーワード）
     * @param {InlineObject27} [inlineObject27]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ItemSearchApi
     */
    ItemSearchApi.prototype.itemSearchFreeword = function (inlineObject27, options) {
        return ItemSearchApiFp(this.configuration).itemSearchFreeword(inlineObject27, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary 商品取得（グループ）
     * @param {InlineObject28} [inlineObject28]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ItemSearchApi
     */
    ItemSearchApi.prototype.itemSearchGroup = function (inlineObject28, options) {
        return ItemSearchApiFp(this.configuration).itemSearchGroup(inlineObject28, options)(this.axios, this.basePath);
    };
    return ItemSearchApi;
}(BaseAPI));
export { ItemSearchApi };
/**
 * LoginApi - axios parameter creator
 * @export
 */
export var LoginApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary null
         * @param {Login} login
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        login: function (login, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'login' is not null or undefined
            if (login === null || login === undefined) {
                throw new RequiredError('login', 'Required parameter login was null or undefined when calling login.');
            }
            var localVarPath = "/login";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'POST' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("Login" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(login !== undefined ? login : {}) : (login || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary null
         * @param {Login} login
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        token: function (login, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'login' is not null or undefined
            if (login === null || login === undefined) {
                throw new RequiredError('login', 'Required parameter login was null or undefined when calling token.');
            }
            var localVarPath = "/token";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'POST' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("Login" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(login !== undefined ? login : {}) : (login || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * LoginApi - functional programming interface
 * @export
 */
export var LoginApiFp = function (configuration) {
    return {
        /**
         *
         * @summary null
         * @param {Login} login
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        login: function (login, options) {
            var localVarAxiosArgs = LoginApiAxiosParamCreator(configuration).login(login, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary null
         * @param {Login} login
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        token: function (login, options) {
            var localVarAxiosArgs = LoginApiAxiosParamCreator(configuration).token(login, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
    };
};
/**
 * LoginApi - factory interface
 * @export
 */
export var LoginApiFactory = function (configuration, basePath, axios) {
    return {
        /**
         *
         * @summary null
         * @param {Login} login
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        login: function (login, options) {
            return LoginApiFp(configuration).login(login, options)(axios, basePath);
        },
        /**
         *
         * @summary null
         * @param {Login} login
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        token: function (login, options) {
            return LoginApiFp(configuration).token(login, options)(axios, basePath);
        },
    };
};
/**
 * LoginApi - object-oriented interface
 * @export
 * @class LoginApi
 * @extends {BaseAPI}
 */
var LoginApi = /** @class */ (function (_super) {
    __extends(LoginApi, _super);
    function LoginApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary null
     * @param {Login} login
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoginApi
     */
    LoginApi.prototype.login = function (login, options) {
        return LoginApiFp(this.configuration).login(login, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary null
     * @param {Login} login
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoginApi
     */
    LoginApi.prototype.token = function (login, options) {
        return LoginApiFp(this.configuration).token(login, options)(this.axios, this.basePath);
    };
    return LoginApi;
}(BaseAPI));
export { LoginApi };
/**
 * LogoutApi - axios parameter creator
 * @export
 */
export var LogoutApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary null
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logout: function (options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/logout";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'POST' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * LogoutApi - functional programming interface
 * @export
 */
export var LogoutApiFp = function (configuration) {
    return {
        /**
         *
         * @summary null
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logout: function (options) {
            var localVarAxiosArgs = LogoutApiAxiosParamCreator(configuration).logout(options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
    };
};
/**
 * LogoutApi - factory interface
 * @export
 */
export var LogoutApiFactory = function (configuration, basePath, axios) {
    return {
        /**
         *
         * @summary null
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logout: function (options) {
            return LogoutApiFp(configuration).logout(options)(axios, basePath);
        },
    };
};
/**
 * LogoutApi - object-oriented interface
 * @export
 * @class LogoutApi
 * @extends {BaseAPI}
 */
var LogoutApi = /** @class */ (function (_super) {
    __extends(LogoutApi, _super);
    function LogoutApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary null
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LogoutApi
     */
    LogoutApi.prototype.logout = function (options) {
        return LogoutApiFp(this.configuration).logout(options)(this.axios, this.basePath);
    };
    return LogoutApi;
}(BaseAPI));
export { LogoutApi };
/**
 * MakerApi - axios parameter creator
 * @export
 */
export var MakerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary メーカー一覧
         * @param {number} [pageNo] 表示するページ数
         * @param {number} [pageSize] ページ内に表示するリストの数。0の場合は全件取得する
         * @param {string} [sortField] ソート対象名
         * @param {string} [sortType] 昇順、降順(\&quot;-\&quot;:昇順、省略時:降順)
         * @param {string} [freeword] フリーワード検索
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        makerList: function (pageNo, pageSize, sortField, sortType, freeword, options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/maker/list";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (pageNo !== undefined) {
                localVarQueryParameter['page_no'] = pageNo;
            }
            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }
            if (sortField !== undefined) {
                localVarQueryParameter['sort_field'] = sortField;
            }
            if (sortType !== undefined) {
                localVarQueryParameter['sort_type'] = sortType;
            }
            if (freeword !== undefined) {
                localVarQueryParameter['freeword'] = freeword;
            }
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * MakerApi - functional programming interface
 * @export
 */
export var MakerApiFp = function (configuration) {
    return {
        /**
         *
         * @summary メーカー一覧
         * @param {number} [pageNo] 表示するページ数
         * @param {number} [pageSize] ページ内に表示するリストの数。0の場合は全件取得する
         * @param {string} [sortField] ソート対象名
         * @param {string} [sortType] 昇順、降順(\&quot;-\&quot;:昇順、省略時:降順)
         * @param {string} [freeword] フリーワード検索
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        makerList: function (pageNo, pageSize, sortField, sortType, freeword, options) {
            var localVarAxiosArgs = MakerApiAxiosParamCreator(configuration).makerList(pageNo, pageSize, sortField, sortType, freeword, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
    };
};
/**
 * MakerApi - factory interface
 * @export
 */
export var MakerApiFactory = function (configuration, basePath, axios) {
    return {
        /**
         *
         * @summary メーカー一覧
         * @param {number} [pageNo] 表示するページ数
         * @param {number} [pageSize] ページ内に表示するリストの数。0の場合は全件取得する
         * @param {string} [sortField] ソート対象名
         * @param {string} [sortType] 昇順、降順(\&quot;-\&quot;:昇順、省略時:降順)
         * @param {string} [freeword] フリーワード検索
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        makerList: function (pageNo, pageSize, sortField, sortType, freeword, options) {
            return MakerApiFp(configuration).makerList(pageNo, pageSize, sortField, sortType, freeword, options)(axios, basePath);
        },
    };
};
/**
 * MakerApi - object-oriented interface
 * @export
 * @class MakerApi
 * @extends {BaseAPI}
 */
var MakerApi = /** @class */ (function (_super) {
    __extends(MakerApi, _super);
    function MakerApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary メーカー一覧
     * @param {number} [pageNo] 表示するページ数
     * @param {number} [pageSize] ページ内に表示するリストの数。0の場合は全件取得する
     * @param {string} [sortField] ソート対象名
     * @param {string} [sortType] 昇順、降順(\&quot;-\&quot;:昇順、省略時:降順)
     * @param {string} [freeword] フリーワード検索
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MakerApi
     */
    MakerApi.prototype.makerList = function (pageNo, pageSize, sortField, sortType, freeword, options) {
        return MakerApiFp(this.configuration).makerList(pageNo, pageSize, sortField, sortType, freeword, options)(this.axios, this.basePath);
    };
    return MakerApi;
}(BaseAPI));
export { MakerApi };
/**
 * ManualApi - axios parameter creator
 * @export
 */
export var ManualApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary マニュアルダウンロード
         * @param {string} slug 対象マニュアル名
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        manualDownload: function (slug, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'slug' is not null or undefined
            if (slug === null || slug === undefined) {
                throw new RequiredError('slug', 'Required parameter slug was null or undefined when calling manualDownload.');
            }
            var localVarPath = "/manual/download/{slug}"
                .replace("{" + "slug" + "}", encodeURIComponent(String(slug)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary マニュアル一覧
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        manualList: function (options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/manual/list";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * ManualApi - functional programming interface
 * @export
 */
export var ManualApiFp = function (configuration) {
    return {
        /**
         *
         * @summary マニュアルダウンロード
         * @param {string} slug 対象マニュアル名
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        manualDownload: function (slug, options) {
            var localVarAxiosArgs = ManualApiAxiosParamCreator(configuration).manualDownload(slug, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary マニュアル一覧
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        manualList: function (options) {
            var localVarAxiosArgs = ManualApiAxiosParamCreator(configuration).manualList(options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
    };
};
/**
 * ManualApi - factory interface
 * @export
 */
export var ManualApiFactory = function (configuration, basePath, axios) {
    return {
        /**
         *
         * @summary マニュアルダウンロード
         * @param {string} slug 対象マニュアル名
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        manualDownload: function (slug, options) {
            return ManualApiFp(configuration).manualDownload(slug, options)(axios, basePath);
        },
        /**
         *
         * @summary マニュアル一覧
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        manualList: function (options) {
            return ManualApiFp(configuration).manualList(options)(axios, basePath);
        },
    };
};
/**
 * ManualApi - object-oriented interface
 * @export
 * @class ManualApi
 * @extends {BaseAPI}
 */
var ManualApi = /** @class */ (function (_super) {
    __extends(ManualApi, _super);
    function ManualApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary マニュアルダウンロード
     * @param {string} slug 対象マニュアル名
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManualApi
     */
    ManualApi.prototype.manualDownload = function (slug, options) {
        return ManualApiFp(this.configuration).manualDownload(slug, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary マニュアル一覧
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManualApi
     */
    ManualApi.prototype.manualList = function (options) {
        return ManualApiFp(this.configuration).manualList(options)(this.axios, this.basePath);
    };
    return ManualApi;
}(BaseAPI));
export { ManualApi };
/**
 * MemberGroupApi - axios parameter creator
 * @export
 */
export var MemberGroupApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary null
         * @param {MemberGroupFormAdd} memberGroupFormAdd
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        memberGroupAdd: function (memberGroupFormAdd, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'memberGroupFormAdd' is not null or undefined
            if (memberGroupFormAdd === null || memberGroupFormAdd === undefined) {
                throw new RequiredError('memberGroupFormAdd', 'Required parameter memberGroupFormAdd was null or undefined when calling memberGroupAdd.');
            }
            var localVarPath = "/member_group";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'POST' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("MemberGroupFormAdd" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(memberGroupFormAdd !== undefined ? memberGroupFormAdd : {}) : (memberGroupFormAdd || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 顧客グループ削除
         * @param {Array<object>} requestBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        memberGroupDelete: function (requestBody, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'requestBody' is not null or undefined
            if (requestBody === null || requestBody === undefined) {
                throw new RequiredError('requestBody', 'Required parameter requestBody was null or undefined when calling memberGroupDelete.');
            }
            var localVarPath = "/member_group";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'DELETE' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("Array&lt;object&gt;" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(requestBody !== undefined ? requestBody : {}) : (requestBody || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary null
         * @param {number} id 対象のID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        memberGroupDetail: function (id, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id', 'Required parameter id was null or undefined when calling memberGroupDetail.');
            }
            var localVarPath = "/member_group/{id}"
                .replace("{" + "id" + "}", encodeURIComponent(String(id)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 顧客グループダウンロード
         * @param {InlineObject5} [inlineObject5]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        memberGroupDownload: function (inlineObject5, options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/member_group/download";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'POST' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("InlineObject5" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(inlineObject5 !== undefined ? inlineObject5 : {}) : (inlineObject5 || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary null
         * @param {MemberGroupFormEdit} memberGroupFormEdit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        memberGroupEdit: function (memberGroupFormEdit, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'memberGroupFormEdit' is not null or undefined
            if (memberGroupFormEdit === null || memberGroupFormEdit === undefined) {
                throw new RequiredError('memberGroupFormEdit', 'Required parameter memberGroupFormEdit was null or undefined when calling memberGroupEdit.');
            }
            var localVarPath = "/member_group";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'PUT' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("MemberGroupFormEdit" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(memberGroupFormEdit !== undefined ? memberGroupFormEdit : {}) : (memberGroupFormEdit || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 顧客グループ一覧
         * @param {number} [pageNo] 表示するページ数
         * @param {number} [pageSize] ページ内に表示するリストの数。0の場合は全件取得する
         * @param {string} [sortField] ソート対象名
         * @param {string} [sortType] 昇順、降順(\&quot;-\&quot;:昇順、省略時:降順)
         * @param {string} [freeword] フリーワード検索
         * @param {string} [status]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        memberGroupList: function (pageNo, pageSize, sortField, sortType, freeword, status, options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/member_group/list";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (pageNo !== undefined) {
                localVarQueryParameter['page_no'] = pageNo;
            }
            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }
            if (sortField !== undefined) {
                localVarQueryParameter['sort_field'] = sortField;
            }
            if (sortType !== undefined) {
                localVarQueryParameter['sort_type'] = sortType;
            }
            if (freeword !== undefined) {
                localVarQueryParameter['freeword'] = freeword;
            }
            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * MemberGroupApi - functional programming interface
 * @export
 */
export var MemberGroupApiFp = function (configuration) {
    return {
        /**
         *
         * @summary null
         * @param {MemberGroupFormAdd} memberGroupFormAdd
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        memberGroupAdd: function (memberGroupFormAdd, options) {
            var localVarAxiosArgs = MemberGroupApiAxiosParamCreator(configuration).memberGroupAdd(memberGroupFormAdd, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary 顧客グループ削除
         * @param {Array<object>} requestBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        memberGroupDelete: function (requestBody, options) {
            var localVarAxiosArgs = MemberGroupApiAxiosParamCreator(configuration).memberGroupDelete(requestBody, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary null
         * @param {number} id 対象のID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        memberGroupDetail: function (id, options) {
            var localVarAxiosArgs = MemberGroupApiAxiosParamCreator(configuration).memberGroupDetail(id, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary 顧客グループダウンロード
         * @param {InlineObject5} [inlineObject5]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        memberGroupDownload: function (inlineObject5, options) {
            var localVarAxiosArgs = MemberGroupApiAxiosParamCreator(configuration).memberGroupDownload(inlineObject5, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary null
         * @param {MemberGroupFormEdit} memberGroupFormEdit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        memberGroupEdit: function (memberGroupFormEdit, options) {
            var localVarAxiosArgs = MemberGroupApiAxiosParamCreator(configuration).memberGroupEdit(memberGroupFormEdit, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary 顧客グループ一覧
         * @param {number} [pageNo] 表示するページ数
         * @param {number} [pageSize] ページ内に表示するリストの数。0の場合は全件取得する
         * @param {string} [sortField] ソート対象名
         * @param {string} [sortType] 昇順、降順(\&quot;-\&quot;:昇順、省略時:降順)
         * @param {string} [freeword] フリーワード検索
         * @param {string} [status]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        memberGroupList: function (pageNo, pageSize, sortField, sortType, freeword, status, options) {
            var localVarAxiosArgs = MemberGroupApiAxiosParamCreator(configuration).memberGroupList(pageNo, pageSize, sortField, sortType, freeword, status, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
    };
};
/**
 * MemberGroupApi - factory interface
 * @export
 */
export var MemberGroupApiFactory = function (configuration, basePath, axios) {
    return {
        /**
         *
         * @summary null
         * @param {MemberGroupFormAdd} memberGroupFormAdd
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        memberGroupAdd: function (memberGroupFormAdd, options) {
            return MemberGroupApiFp(configuration).memberGroupAdd(memberGroupFormAdd, options)(axios, basePath);
        },
        /**
         *
         * @summary 顧客グループ削除
         * @param {Array<object>} requestBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        memberGroupDelete: function (requestBody, options) {
            return MemberGroupApiFp(configuration).memberGroupDelete(requestBody, options)(axios, basePath);
        },
        /**
         *
         * @summary null
         * @param {number} id 対象のID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        memberGroupDetail: function (id, options) {
            return MemberGroupApiFp(configuration).memberGroupDetail(id, options)(axios, basePath);
        },
        /**
         *
         * @summary 顧客グループダウンロード
         * @param {InlineObject5} [inlineObject5]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        memberGroupDownload: function (inlineObject5, options) {
            return MemberGroupApiFp(configuration).memberGroupDownload(inlineObject5, options)(axios, basePath);
        },
        /**
         *
         * @summary null
         * @param {MemberGroupFormEdit} memberGroupFormEdit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        memberGroupEdit: function (memberGroupFormEdit, options) {
            return MemberGroupApiFp(configuration).memberGroupEdit(memberGroupFormEdit, options)(axios, basePath);
        },
        /**
         *
         * @summary 顧客グループ一覧
         * @param {number} [pageNo] 表示するページ数
         * @param {number} [pageSize] ページ内に表示するリストの数。0の場合は全件取得する
         * @param {string} [sortField] ソート対象名
         * @param {string} [sortType] 昇順、降順(\&quot;-\&quot;:昇順、省略時:降順)
         * @param {string} [freeword] フリーワード検索
         * @param {string} [status]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        memberGroupList: function (pageNo, pageSize, sortField, sortType, freeword, status, options) {
            return MemberGroupApiFp(configuration).memberGroupList(pageNo, pageSize, sortField, sortType, freeword, status, options)(axios, basePath);
        },
    };
};
/**
 * MemberGroupApi - object-oriented interface
 * @export
 * @class MemberGroupApi
 * @extends {BaseAPI}
 */
var MemberGroupApi = /** @class */ (function (_super) {
    __extends(MemberGroupApi, _super);
    function MemberGroupApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary null
     * @param {MemberGroupFormAdd} memberGroupFormAdd
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MemberGroupApi
     */
    MemberGroupApi.prototype.memberGroupAdd = function (memberGroupFormAdd, options) {
        return MemberGroupApiFp(this.configuration).memberGroupAdd(memberGroupFormAdd, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary 顧客グループ削除
     * @param {Array<object>} requestBody
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MemberGroupApi
     */
    MemberGroupApi.prototype.memberGroupDelete = function (requestBody, options) {
        return MemberGroupApiFp(this.configuration).memberGroupDelete(requestBody, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary null
     * @param {number} id 対象のID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MemberGroupApi
     */
    MemberGroupApi.prototype.memberGroupDetail = function (id, options) {
        return MemberGroupApiFp(this.configuration).memberGroupDetail(id, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary 顧客グループダウンロード
     * @param {InlineObject5} [inlineObject5]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MemberGroupApi
     */
    MemberGroupApi.prototype.memberGroupDownload = function (inlineObject5, options) {
        return MemberGroupApiFp(this.configuration).memberGroupDownload(inlineObject5, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary null
     * @param {MemberGroupFormEdit} memberGroupFormEdit
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MemberGroupApi
     */
    MemberGroupApi.prototype.memberGroupEdit = function (memberGroupFormEdit, options) {
        return MemberGroupApiFp(this.configuration).memberGroupEdit(memberGroupFormEdit, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary 顧客グループ一覧
     * @param {number} [pageNo] 表示するページ数
     * @param {number} [pageSize] ページ内に表示するリストの数。0の場合は全件取得する
     * @param {string} [sortField] ソート対象名
     * @param {string} [sortType] 昇順、降順(\&quot;-\&quot;:昇順、省略時:降順)
     * @param {string} [freeword] フリーワード検索
     * @param {string} [status]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MemberGroupApi
     */
    MemberGroupApi.prototype.memberGroupList = function (pageNo, pageSize, sortField, sortType, freeword, status, options) {
        return MemberGroupApiFp(this.configuration).memberGroupList(pageNo, pageSize, sortField, sortType, freeword, status, options)(this.axios, this.basePath);
    };
    return MemberGroupApi;
}(BaseAPI));
export { MemberGroupApi };
/**
 * MemberSearchApi - axios parameter creator
 * @export
 */
export var MemberSearchApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary 会員取得（コード）
         * @param {InlineObject29} [inlineObject29]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        memberSearchCode: function (inlineObject29, options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/member_search/code";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'POST' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("InlineObject29" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(inlineObject29 !== undefined ? inlineObject29 : {}) : (inlineObject29 || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 会員取得（グループ）
         * @param {InlineObject30} [inlineObject30]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        memberSearchGroup: function (inlineObject30, options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/member_search/group";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'POST' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("InlineObject30" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(inlineObject30 !== undefined ? inlineObject30 : {}) : (inlineObject30 || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 会員取得（会員コードファイルアップロード）
         * @param {Array<InlineObject>} [inlineObject] code：取得したい会員コード配列
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        memberSearchName: function (inlineObject, options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/member_search/file";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'POST' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("Array&lt;InlineObject&gt;" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(inlineObject !== undefined ? inlineObject : {}) : (inlineObject || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * MemberSearchApi - functional programming interface
 * @export
 */
export var MemberSearchApiFp = function (configuration) {
    return {
        /**
         *
         * @summary 会員取得（コード）
         * @param {InlineObject29} [inlineObject29]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        memberSearchCode: function (inlineObject29, options) {
            var localVarAxiosArgs = MemberSearchApiAxiosParamCreator(configuration).memberSearchCode(inlineObject29, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary 会員取得（グループ）
         * @param {InlineObject30} [inlineObject30]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        memberSearchGroup: function (inlineObject30, options) {
            var localVarAxiosArgs = MemberSearchApiAxiosParamCreator(configuration).memberSearchGroup(inlineObject30, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary 会員取得（会員コードファイルアップロード）
         * @param {Array<InlineObject>} [inlineObject] code：取得したい会員コード配列
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        memberSearchName: function (inlineObject, options) {
            var localVarAxiosArgs = MemberSearchApiAxiosParamCreator(configuration).memberSearchName(inlineObject, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
    };
};
/**
 * MemberSearchApi - factory interface
 * @export
 */
export var MemberSearchApiFactory = function (configuration, basePath, axios) {
    return {
        /**
         *
         * @summary 会員取得（コード）
         * @param {InlineObject29} [inlineObject29]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        memberSearchCode: function (inlineObject29, options) {
            return MemberSearchApiFp(configuration).memberSearchCode(inlineObject29, options)(axios, basePath);
        },
        /**
         *
         * @summary 会員取得（グループ）
         * @param {InlineObject30} [inlineObject30]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        memberSearchGroup: function (inlineObject30, options) {
            return MemberSearchApiFp(configuration).memberSearchGroup(inlineObject30, options)(axios, basePath);
        },
        /**
         *
         * @summary 会員取得（会員コードファイルアップロード）
         * @param {Array<InlineObject>} [inlineObject] code：取得したい会員コード配列
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        memberSearchName: function (inlineObject, options) {
            return MemberSearchApiFp(configuration).memberSearchName(inlineObject, options)(axios, basePath);
        },
    };
};
/**
 * MemberSearchApi - object-oriented interface
 * @export
 * @class MemberSearchApi
 * @extends {BaseAPI}
 */
var MemberSearchApi = /** @class */ (function (_super) {
    __extends(MemberSearchApi, _super);
    function MemberSearchApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary 会員取得（コード）
     * @param {InlineObject29} [inlineObject29]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MemberSearchApi
     */
    MemberSearchApi.prototype.memberSearchCode = function (inlineObject29, options) {
        return MemberSearchApiFp(this.configuration).memberSearchCode(inlineObject29, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary 会員取得（グループ）
     * @param {InlineObject30} [inlineObject30]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MemberSearchApi
     */
    MemberSearchApi.prototype.memberSearchGroup = function (inlineObject30, options) {
        return MemberSearchApiFp(this.configuration).memberSearchGroup(inlineObject30, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary 会員取得（会員コードファイルアップロード）
     * @param {Array<InlineObject>} [inlineObject] code：取得したい会員コード配列
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MemberSearchApi
     */
    MemberSearchApi.prototype.memberSearchName = function (inlineObject, options) {
        return MemberSearchApiFp(this.configuration).memberSearchName(inlineObject, options)(this.axios, this.basePath);
    };
    return MemberSearchApi;
}(BaseAPI));
export { MemberSearchApi };
/**
 * NoticeApi - axios parameter creator
 * @export
 */
export var NoticeApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary お知らせ登録
         * @param {NoticeModel} noticeModel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        noticeAdd: function (noticeModel, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'noticeModel' is not null or undefined
            if (noticeModel === null || noticeModel === undefined) {
                throw new RequiredError('noticeModel', 'Required parameter noticeModel was null or undefined when calling noticeAdd.');
            }
            var localVarPath = "/notice";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'POST' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("NoticeModel" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(noticeModel !== undefined ? noticeModel : {}) : (noticeModel || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary お知らせ削除
         * @param {Array<object>} requestBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        noticeDelete: function (requestBody, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'requestBody' is not null or undefined
            if (requestBody === null || requestBody === undefined) {
                throw new RequiredError('requestBody', 'Required parameter requestBody was null or undefined when calling noticeDelete.');
            }
            var localVarPath = "/notice";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'DELETE' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("Array&lt;object&gt;" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(requestBody !== undefined ? requestBody : {}) : (requestBody || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary お知らせ明細
         * @param {number} id 対象のID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        noticeDetail: function (id, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id', 'Required parameter id was null or undefined when calling noticeDetail.');
            }
            var localVarPath = "/notice/{id}"
                .replace("{" + "id" + "}", encodeURIComponent(String(id)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary お知らせ更新
         * @param {Notice} notice
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        noticeEdit: function (notice, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'notice' is not null or undefined
            if (notice === null || notice === undefined) {
                throw new RequiredError('notice', 'Required parameter notice was null or undefined when calling noticeEdit.');
            }
            var localVarPath = "/notice";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'PUT' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("Notice" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(notice !== undefined ? notice : {}) : (notice || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary お知らせ管理用リスト
         * @param {number} [pageNo] 表示するページ数
         * @param {number} [pageSize] ページ内に表示するリストの数。0の場合は全件取得する
         * @param {string} [sortField] ソート対象名
         * @param {string} [sortType] 昇順、降順(\&quot;-\&quot;:昇順、省略時:降順)
         * @param {string} [freeword] フリーワード検索
         * @param {number} [contractId] 企業ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        noticeList: function (pageNo, pageSize, sortField, sortType, freeword, contractId, options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/notice/list";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (pageNo !== undefined) {
                localVarQueryParameter['page_no'] = pageNo;
            }
            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }
            if (sortField !== undefined) {
                localVarQueryParameter['sort_field'] = sortField;
            }
            if (sortType !== undefined) {
                localVarQueryParameter['sort_type'] = sortType;
            }
            if (freeword !== undefined) {
                localVarQueryParameter['freeword'] = freeword;
            }
            if (contractId !== undefined) {
                localVarQueryParameter['contract_id'] = contractId;
            }
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary お知らせ全体公開リスト
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        noticePublic: function (options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/notice/public";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary お知らせユーザリスト
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        noticeUserList: function (options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/notice/userlist";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * NoticeApi - functional programming interface
 * @export
 */
export var NoticeApiFp = function (configuration) {
    return {
        /**
         *
         * @summary お知らせ登録
         * @param {NoticeModel} noticeModel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        noticeAdd: function (noticeModel, options) {
            var localVarAxiosArgs = NoticeApiAxiosParamCreator(configuration).noticeAdd(noticeModel, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary お知らせ削除
         * @param {Array<object>} requestBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        noticeDelete: function (requestBody, options) {
            var localVarAxiosArgs = NoticeApiAxiosParamCreator(configuration).noticeDelete(requestBody, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary お知らせ明細
         * @param {number} id 対象のID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        noticeDetail: function (id, options) {
            var localVarAxiosArgs = NoticeApiAxiosParamCreator(configuration).noticeDetail(id, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary お知らせ更新
         * @param {Notice} notice
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        noticeEdit: function (notice, options) {
            var localVarAxiosArgs = NoticeApiAxiosParamCreator(configuration).noticeEdit(notice, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary お知らせ管理用リスト
         * @param {number} [pageNo] 表示するページ数
         * @param {number} [pageSize] ページ内に表示するリストの数。0の場合は全件取得する
         * @param {string} [sortField] ソート対象名
         * @param {string} [sortType] 昇順、降順(\&quot;-\&quot;:昇順、省略時:降順)
         * @param {string} [freeword] フリーワード検索
         * @param {number} [contractId] 企業ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        noticeList: function (pageNo, pageSize, sortField, sortType, freeword, contractId, options) {
            var localVarAxiosArgs = NoticeApiAxiosParamCreator(configuration).noticeList(pageNo, pageSize, sortField, sortType, freeword, contractId, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary お知らせ全体公開リスト
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        noticePublic: function (options) {
            var localVarAxiosArgs = NoticeApiAxiosParamCreator(configuration).noticePublic(options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary お知らせユーザリスト
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        noticeUserList: function (options) {
            var localVarAxiosArgs = NoticeApiAxiosParamCreator(configuration).noticeUserList(options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
    };
};
/**
 * NoticeApi - factory interface
 * @export
 */
export var NoticeApiFactory = function (configuration, basePath, axios) {
    return {
        /**
         *
         * @summary お知らせ登録
         * @param {NoticeModel} noticeModel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        noticeAdd: function (noticeModel, options) {
            return NoticeApiFp(configuration).noticeAdd(noticeModel, options)(axios, basePath);
        },
        /**
         *
         * @summary お知らせ削除
         * @param {Array<object>} requestBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        noticeDelete: function (requestBody, options) {
            return NoticeApiFp(configuration).noticeDelete(requestBody, options)(axios, basePath);
        },
        /**
         *
         * @summary お知らせ明細
         * @param {number} id 対象のID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        noticeDetail: function (id, options) {
            return NoticeApiFp(configuration).noticeDetail(id, options)(axios, basePath);
        },
        /**
         *
         * @summary お知らせ更新
         * @param {Notice} notice
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        noticeEdit: function (notice, options) {
            return NoticeApiFp(configuration).noticeEdit(notice, options)(axios, basePath);
        },
        /**
         *
         * @summary お知らせ管理用リスト
         * @param {number} [pageNo] 表示するページ数
         * @param {number} [pageSize] ページ内に表示するリストの数。0の場合は全件取得する
         * @param {string} [sortField] ソート対象名
         * @param {string} [sortType] 昇順、降順(\&quot;-\&quot;:昇順、省略時:降順)
         * @param {string} [freeword] フリーワード検索
         * @param {number} [contractId] 企業ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        noticeList: function (pageNo, pageSize, sortField, sortType, freeword, contractId, options) {
            return NoticeApiFp(configuration).noticeList(pageNo, pageSize, sortField, sortType, freeword, contractId, options)(axios, basePath);
        },
        /**
         *
         * @summary お知らせ全体公開リスト
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        noticePublic: function (options) {
            return NoticeApiFp(configuration).noticePublic(options)(axios, basePath);
        },
        /**
         *
         * @summary お知らせユーザリスト
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        noticeUserList: function (options) {
            return NoticeApiFp(configuration).noticeUserList(options)(axios, basePath);
        },
    };
};
/**
 * NoticeApi - object-oriented interface
 * @export
 * @class NoticeApi
 * @extends {BaseAPI}
 */
var NoticeApi = /** @class */ (function (_super) {
    __extends(NoticeApi, _super);
    function NoticeApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary お知らせ登録
     * @param {NoticeModel} noticeModel
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NoticeApi
     */
    NoticeApi.prototype.noticeAdd = function (noticeModel, options) {
        return NoticeApiFp(this.configuration).noticeAdd(noticeModel, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary お知らせ削除
     * @param {Array<object>} requestBody
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NoticeApi
     */
    NoticeApi.prototype.noticeDelete = function (requestBody, options) {
        return NoticeApiFp(this.configuration).noticeDelete(requestBody, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary お知らせ明細
     * @param {number} id 対象のID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NoticeApi
     */
    NoticeApi.prototype.noticeDetail = function (id, options) {
        return NoticeApiFp(this.configuration).noticeDetail(id, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary お知らせ更新
     * @param {Notice} notice
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NoticeApi
     */
    NoticeApi.prototype.noticeEdit = function (notice, options) {
        return NoticeApiFp(this.configuration).noticeEdit(notice, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary お知らせ管理用リスト
     * @param {number} [pageNo] 表示するページ数
     * @param {number} [pageSize] ページ内に表示するリストの数。0の場合は全件取得する
     * @param {string} [sortField] ソート対象名
     * @param {string} [sortType] 昇順、降順(\&quot;-\&quot;:昇順、省略時:降順)
     * @param {string} [freeword] フリーワード検索
     * @param {number} [contractId] 企業ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NoticeApi
     */
    NoticeApi.prototype.noticeList = function (pageNo, pageSize, sortField, sortType, freeword, contractId, options) {
        return NoticeApiFp(this.configuration).noticeList(pageNo, pageSize, sortField, sortType, freeword, contractId, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary お知らせ全体公開リスト
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NoticeApi
     */
    NoticeApi.prototype.noticePublic = function (options) {
        return NoticeApiFp(this.configuration).noticePublic(options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary お知らせユーザリスト
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NoticeApi
     */
    NoticeApi.prototype.noticeUserList = function (options) {
        return NoticeApiFp(this.configuration).noticeUserList(options)(this.axios, this.basePath);
    };
    return NoticeApi;
}(BaseAPI));
export { NoticeApi };
/**
 * PasswordApi - axios parameter creator
 * @export
 */
export var PasswordApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary パスワードリマインダー　パスワード変更完了
         * @param {InlineObject} inlineObject
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        passwordComplete: function (inlineObject, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'inlineObject' is not null or undefined
            if (inlineObject === null || inlineObject === undefined) {
                throw new RequiredError('inlineObject', 'Required parameter inlineObject was null or undefined when calling passwordComplete.');
            }
            var localVarPath = "/password/complete";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'POST' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("InlineObject" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(inlineObject !== undefined ? inlineObject : {}) : (inlineObject || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary パスワードリマインダー パスワード再設定画面表示確認
         * @param {string} code JWT文字列
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        passwordInput: function (code, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'code' is not null or undefined
            if (code === null || code === undefined) {
                throw new RequiredError('code', 'Required parameter code was null or undefined when calling passwordInput.');
            }
            var localVarPath = "/password/input/{code}"
                .replace("{" + "code" + "}", encodeURIComponent(String(code)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary パスワードリマインダーのメール送信依頼を行う
         * @param {PasswordSend} passwordSend
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        passwordSend: function (passwordSend, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'passwordSend' is not null or undefined
            if (passwordSend === null || passwordSend === undefined) {
                throw new RequiredError('passwordSend', 'Required parameter passwordSend was null or undefined when calling passwordSend.');
            }
            var localVarPath = "/password/send";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'POST' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("PasswordSend" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(passwordSend !== undefined ? passwordSend : {}) : (passwordSend || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * PasswordApi - functional programming interface
 * @export
 */
export var PasswordApiFp = function (configuration) {
    return {
        /**
         *
         * @summary パスワードリマインダー　パスワード変更完了
         * @param {InlineObject} inlineObject
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        passwordComplete: function (inlineObject, options) {
            var localVarAxiosArgs = PasswordApiAxiosParamCreator(configuration).passwordComplete(inlineObject, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary パスワードリマインダー パスワード再設定画面表示確認
         * @param {string} code JWT文字列
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        passwordInput: function (code, options) {
            var localVarAxiosArgs = PasswordApiAxiosParamCreator(configuration).passwordInput(code, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary パスワードリマインダーのメール送信依頼を行う
         * @param {PasswordSend} passwordSend
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        passwordSend: function (passwordSend, options) {
            var localVarAxiosArgs = PasswordApiAxiosParamCreator(configuration).passwordSend(passwordSend, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
    };
};
/**
 * PasswordApi - factory interface
 * @export
 */
export var PasswordApiFactory = function (configuration, basePath, axios) {
    return {
        /**
         *
         * @summary パスワードリマインダー　パスワード変更完了
         * @param {InlineObject} inlineObject
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        passwordComplete: function (inlineObject, options) {
            return PasswordApiFp(configuration).passwordComplete(inlineObject, options)(axios, basePath);
        },
        /**
         *
         * @summary パスワードリマインダー パスワード再設定画面表示確認
         * @param {string} code JWT文字列
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        passwordInput: function (code, options) {
            return PasswordApiFp(configuration).passwordInput(code, options)(axios, basePath);
        },
        /**
         *
         * @summary パスワードリマインダーのメール送信依頼を行う
         * @param {PasswordSend} passwordSend
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        passwordSend: function (passwordSend, options) {
            return PasswordApiFp(configuration).passwordSend(passwordSend, options)(axios, basePath);
        },
    };
};
/**
 * PasswordApi - object-oriented interface
 * @export
 * @class PasswordApi
 * @extends {BaseAPI}
 */
var PasswordApi = /** @class */ (function (_super) {
    __extends(PasswordApi, _super);
    function PasswordApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary パスワードリマインダー　パスワード変更完了
     * @param {InlineObject} inlineObject
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PasswordApi
     */
    PasswordApi.prototype.passwordComplete = function (inlineObject, options) {
        return PasswordApiFp(this.configuration).passwordComplete(inlineObject, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary パスワードリマインダー パスワード再設定画面表示確認
     * @param {string} code JWT文字列
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PasswordApi
     */
    PasswordApi.prototype.passwordInput = function (code, options) {
        return PasswordApiFp(this.configuration).passwordInput(code, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary パスワードリマインダーのメール送信依頼を行う
     * @param {PasswordSend} passwordSend
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PasswordApi
     */
    PasswordApi.prototype.passwordSend = function (passwordSend, options) {
        return PasswordApiFp(this.configuration).passwordSend(passwordSend, options)(this.axios, this.basePath);
    };
    return PasswordApi;
}(BaseAPI));
export { PasswordApi };
/**
 * ProductAttributeApi - axios parameter creator
 * @export
 */
export var ProductAttributeApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary 商品属性小項目一覧
         * @param {InlineObject6} [inlineObject6]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productAttributeChildList: function (inlineObject6, options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/product_attribute/child_list";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'POST' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("InlineObject6" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(inlineObject6 !== undefined ? inlineObject6 : {}) : (inlineObject6 || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 商品属性削除
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productAttributeDelete: function (options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/product_attribute";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'DELETE' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 商品属性JANコード一覧
         * @param {InlineObject7} [inlineObject7]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productAttributeJancdList: function (inlineObject7, options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/product_attribute/jan_list";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'POST' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("InlineObject7" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(inlineObject7 !== undefined ? inlineObject7 : {}) : (inlineObject7 || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 商品属性大項目一覧
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productAttributeParentList: function (options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/product_attribute/parent_list";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 商品属性アップロード完了
         * @param {any} [uploadData]
         * @param {any} [excelProduct]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productAttributeSave: function (uploadData, excelProduct, options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/product_attribute/save";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'POST' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            var localVarFormParams = new FormData();
            if (uploadData !== undefined) {
                localVarFormParams.append('upload_data', uploadData);
            }
            if (excelProduct !== undefined) {
                localVarFormParams.append('excel_product', excelProduct);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            localVarRequestOptions.data = localVarFormParams;
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 商品属性アップロード
         * @param {string} [productAttributeDate]
         * @param {any} [excelProduct]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productAttributeUpload: function (productAttributeDate, excelProduct, options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/product_attribute/upload";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'POST' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            var localVarFormParams = new FormData();
            if (productAttributeDate !== undefined) {
                localVarFormParams.append('productAttributeDate', productAttributeDate);
            }
            if (excelProduct !== undefined) {
                localVarFormParams.append('excel_product', excelProduct);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            localVarRequestOptions.data = localVarFormParams;
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * ProductAttributeApi - functional programming interface
 * @export
 */
export var ProductAttributeApiFp = function (configuration) {
    return {
        /**
         *
         * @summary 商品属性小項目一覧
         * @param {InlineObject6} [inlineObject6]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productAttributeChildList: function (inlineObject6, options) {
            var localVarAxiosArgs = ProductAttributeApiAxiosParamCreator(configuration).productAttributeChildList(inlineObject6, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary 商品属性削除
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productAttributeDelete: function (options) {
            var localVarAxiosArgs = ProductAttributeApiAxiosParamCreator(configuration).productAttributeDelete(options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary 商品属性JANコード一覧
         * @param {InlineObject7} [inlineObject7]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productAttributeJancdList: function (inlineObject7, options) {
            var localVarAxiosArgs = ProductAttributeApiAxiosParamCreator(configuration).productAttributeJancdList(inlineObject7, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary 商品属性大項目一覧
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productAttributeParentList: function (options) {
            var localVarAxiosArgs = ProductAttributeApiAxiosParamCreator(configuration).productAttributeParentList(options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary 商品属性アップロード完了
         * @param {any} [uploadData]
         * @param {any} [excelProduct]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productAttributeSave: function (uploadData, excelProduct, options) {
            var localVarAxiosArgs = ProductAttributeApiAxiosParamCreator(configuration).productAttributeSave(uploadData, excelProduct, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary 商品属性アップロード
         * @param {string} [productAttributeDate]
         * @param {any} [excelProduct]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productAttributeUpload: function (productAttributeDate, excelProduct, options) {
            var localVarAxiosArgs = ProductAttributeApiAxiosParamCreator(configuration).productAttributeUpload(productAttributeDate, excelProduct, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
    };
};
/**
 * ProductAttributeApi - factory interface
 * @export
 */
export var ProductAttributeApiFactory = function (configuration, basePath, axios) {
    return {
        /**
         *
         * @summary 商品属性小項目一覧
         * @param {InlineObject6} [inlineObject6]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productAttributeChildList: function (inlineObject6, options) {
            return ProductAttributeApiFp(configuration).productAttributeChildList(inlineObject6, options)(axios, basePath);
        },
        /**
         *
         * @summary 商品属性削除
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productAttributeDelete: function (options) {
            return ProductAttributeApiFp(configuration).productAttributeDelete(options)(axios, basePath);
        },
        /**
         *
         * @summary 商品属性JANコード一覧
         * @param {InlineObject7} [inlineObject7]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productAttributeJancdList: function (inlineObject7, options) {
            return ProductAttributeApiFp(configuration).productAttributeJancdList(inlineObject7, options)(axios, basePath);
        },
        /**
         *
         * @summary 商品属性大項目一覧
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productAttributeParentList: function (options) {
            return ProductAttributeApiFp(configuration).productAttributeParentList(options)(axios, basePath);
        },
        /**
         *
         * @summary 商品属性アップロード完了
         * @param {any} [uploadData]
         * @param {any} [excelProduct]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productAttributeSave: function (uploadData, excelProduct, options) {
            return ProductAttributeApiFp(configuration).productAttributeSave(uploadData, excelProduct, options)(axios, basePath);
        },
        /**
         *
         * @summary 商品属性アップロード
         * @param {string} [productAttributeDate]
         * @param {any} [excelProduct]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productAttributeUpload: function (productAttributeDate, excelProduct, options) {
            return ProductAttributeApiFp(configuration).productAttributeUpload(productAttributeDate, excelProduct, options)(axios, basePath);
        },
    };
};
/**
 * ProductAttributeApi - object-oriented interface
 * @export
 * @class ProductAttributeApi
 * @extends {BaseAPI}
 */
var ProductAttributeApi = /** @class */ (function (_super) {
    __extends(ProductAttributeApi, _super);
    function ProductAttributeApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary 商品属性小項目一覧
     * @param {InlineObject6} [inlineObject6]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductAttributeApi
     */
    ProductAttributeApi.prototype.productAttributeChildList = function (inlineObject6, options) {
        return ProductAttributeApiFp(this.configuration).productAttributeChildList(inlineObject6, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary 商品属性削除
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductAttributeApi
     */
    ProductAttributeApi.prototype.productAttributeDelete = function (options) {
        return ProductAttributeApiFp(this.configuration).productAttributeDelete(options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary 商品属性JANコード一覧
     * @param {InlineObject7} [inlineObject7]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductAttributeApi
     */
    ProductAttributeApi.prototype.productAttributeJancdList = function (inlineObject7, options) {
        return ProductAttributeApiFp(this.configuration).productAttributeJancdList(inlineObject7, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary 商品属性大項目一覧
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductAttributeApi
     */
    ProductAttributeApi.prototype.productAttributeParentList = function (options) {
        return ProductAttributeApiFp(this.configuration).productAttributeParentList(options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary 商品属性アップロード完了
     * @param {any} [uploadData]
     * @param {any} [excelProduct]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductAttributeApi
     */
    ProductAttributeApi.prototype.productAttributeSave = function (uploadData, excelProduct, options) {
        return ProductAttributeApiFp(this.configuration).productAttributeSave(uploadData, excelProduct, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary 商品属性アップロード
     * @param {string} [productAttributeDate]
     * @param {any} [excelProduct]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductAttributeApi
     */
    ProductAttributeApi.prototype.productAttributeUpload = function (productAttributeDate, excelProduct, options) {
        return ProductAttributeApiFp(this.configuration).productAttributeUpload(productAttributeDate, excelProduct, options)(this.axios, this.basePath);
    };
    return ProductAttributeApi;
}(BaseAPI));
export { ProductAttributeApi };
/**
 * ProductCategoryApi - axios parameter creator
 * @export
 */
export var ProductCategoryApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary 商品カテゴリ一覧
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productCategoryList: function (options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/product_category/list";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'POST' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * ProductCategoryApi - functional programming interface
 * @export
 */
export var ProductCategoryApiFp = function (configuration) {
    return {
        /**
         *
         * @summary 商品カテゴリ一覧
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productCategoryList: function (options) {
            var localVarAxiosArgs = ProductCategoryApiAxiosParamCreator(configuration).productCategoryList(options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
    };
};
/**
 * ProductCategoryApi - factory interface
 * @export
 */
export var ProductCategoryApiFactory = function (configuration, basePath, axios) {
    return {
        /**
         *
         * @summary 商品カテゴリ一覧
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productCategoryList: function (options) {
            return ProductCategoryApiFp(configuration).productCategoryList(options)(axios, basePath);
        },
    };
};
/**
 * ProductCategoryApi - object-oriented interface
 * @export
 * @class ProductCategoryApi
 * @extends {BaseAPI}
 */
var ProductCategoryApi = /** @class */ (function (_super) {
    __extends(ProductCategoryApi, _super);
    function ProductCategoryApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary 商品カテゴリ一覧
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductCategoryApi
     */
    ProductCategoryApi.prototype.productCategoryList = function (options) {
        return ProductCategoryApiFp(this.configuration).productCategoryList(options)(this.axios, this.basePath);
    };
    return ProductCategoryApi;
}(BaseAPI));
export { ProductCategoryApi };
/**
 * ProductGroupApi - axios parameter creator
 * @export
 */
export var ProductGroupApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary null
         * @param {ProductGroupFormAdd} productGroupFormAdd
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productGroupAdd: function (productGroupFormAdd, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'productGroupFormAdd' is not null or undefined
            if (productGroupFormAdd === null || productGroupFormAdd === undefined) {
                throw new RequiredError('productGroupFormAdd', 'Required parameter productGroupFormAdd was null or undefined when calling productGroupAdd.');
            }
            var localVarPath = "/product_group";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'POST' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("ProductGroupFormAdd" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(productGroupFormAdd !== undefined ? productGroupFormAdd : {}) : (productGroupFormAdd || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 商品グループ削除
         * @param {Array<object>} requestBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productGroupDelete: function (requestBody, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'requestBody' is not null or undefined
            if (requestBody === null || requestBody === undefined) {
                throw new RequiredError('requestBody', 'Required parameter requestBody was null or undefined when calling productGroupDelete.');
            }
            var localVarPath = "/product_group";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'DELETE' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("Array&lt;object&gt;" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(requestBody !== undefined ? requestBody : {}) : (requestBody || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 商品グループダウンロード
         * @param {InlineObject3} [inlineObject3]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productGroupDownload: function (inlineObject3, options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/product_group/download";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'POST' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("InlineObject3" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(inlineObject3 !== undefined ? inlineObject3 : {}) : (inlineObject3 || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary null
         * @param {ProductGroupFormEdit} productGroupFormEdit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productGroupEdit: function (productGroupFormEdit, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'productGroupFormEdit' is not null or undefined
            if (productGroupFormEdit === null || productGroupFormEdit === undefined) {
                throw new RequiredError('productGroupFormEdit', 'Required parameter productGroupFormEdit was null or undefined when calling productGroupEdit.');
            }
            var localVarPath = "/product_group";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'PUT' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("ProductGroupFormEdit" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(productGroupFormEdit !== undefined ? productGroupFormEdit : {}) : (productGroupFormEdit || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 商品グループ詳細
         * @param {number} id 対象のID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productGroupJanDetail: function (id, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id', 'Required parameter id was null or undefined when calling productGroupJanDetail.');
            }
            var localVarPath = "/product_group/jan/{id}"
                .replace("{" + "id" + "}", encodeURIComponent(String(id)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary null
         * @param {number} [pageNo] 表示するページ数
         * @param {number} [pageSize] ページ内に表示するリストの数。0の場合は全件取得する
         * @param {string} [sortField] ソート対象名
         * @param {string} [sortType] 昇順、降順(\&quot;-\&quot;:昇順、省略時:降順)
         * @param {string} [freeword] フリーワード検索
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productGroupList: function (pageNo, pageSize, sortField, sortType, freeword, options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/product_group/list";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (pageNo !== undefined) {
                localVarQueryParameter['page_no'] = pageNo;
            }
            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }
            if (sortField !== undefined) {
                localVarQueryParameter['sort_field'] = sortField;
            }
            if (sortType !== undefined) {
                localVarQueryParameter['sort_type'] = sortType;
            }
            if (freeword !== undefined) {
                localVarQueryParameter['freeword'] = freeword;
            }
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 商品グループ詳細
         * @param {number} id 対象のID
         * @param {string} productAreaCode 対象の商品エリアコード
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productGroupProductDetail: function (id, productAreaCode, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id', 'Required parameter id was null or undefined when calling productGroupProductDetail.');
            }
            // verify required parameter 'productAreaCode' is not null or undefined
            if (productAreaCode === null || productAreaCode === undefined) {
                throw new RequiredError('productAreaCode', 'Required parameter productAreaCode was null or undefined when calling productGroupProductDetail.');
            }
            var localVarPath = "/product_group/product/{id}/{product_area_code}"
                .replace("{" + "id" + "}", encodeURIComponent(String(id)))
                .replace("{" + "product_area_code" + "}", encodeURIComponent(String(productAreaCode)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * ProductGroupApi - functional programming interface
 * @export
 */
export var ProductGroupApiFp = function (configuration) {
    return {
        /**
         *
         * @summary null
         * @param {ProductGroupFormAdd} productGroupFormAdd
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productGroupAdd: function (productGroupFormAdd, options) {
            var localVarAxiosArgs = ProductGroupApiAxiosParamCreator(configuration).productGroupAdd(productGroupFormAdd, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary 商品グループ削除
         * @param {Array<object>} requestBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productGroupDelete: function (requestBody, options) {
            var localVarAxiosArgs = ProductGroupApiAxiosParamCreator(configuration).productGroupDelete(requestBody, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary 商品グループダウンロード
         * @param {InlineObject3} [inlineObject3]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productGroupDownload: function (inlineObject3, options) {
            var localVarAxiosArgs = ProductGroupApiAxiosParamCreator(configuration).productGroupDownload(inlineObject3, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary null
         * @param {ProductGroupFormEdit} productGroupFormEdit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productGroupEdit: function (productGroupFormEdit, options) {
            var localVarAxiosArgs = ProductGroupApiAxiosParamCreator(configuration).productGroupEdit(productGroupFormEdit, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary 商品グループ詳細
         * @param {number} id 対象のID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productGroupJanDetail: function (id, options) {
            var localVarAxiosArgs = ProductGroupApiAxiosParamCreator(configuration).productGroupJanDetail(id, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary null
         * @param {number} [pageNo] 表示するページ数
         * @param {number} [pageSize] ページ内に表示するリストの数。0の場合は全件取得する
         * @param {string} [sortField] ソート対象名
         * @param {string} [sortType] 昇順、降順(\&quot;-\&quot;:昇順、省略時:降順)
         * @param {string} [freeword] フリーワード検索
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productGroupList: function (pageNo, pageSize, sortField, sortType, freeword, options) {
            var localVarAxiosArgs = ProductGroupApiAxiosParamCreator(configuration).productGroupList(pageNo, pageSize, sortField, sortType, freeword, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary 商品グループ詳細
         * @param {number} id 対象のID
         * @param {string} productAreaCode 対象の商品エリアコード
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productGroupProductDetail: function (id, productAreaCode, options) {
            var localVarAxiosArgs = ProductGroupApiAxiosParamCreator(configuration).productGroupProductDetail(id, productAreaCode, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
    };
};
/**
 * ProductGroupApi - factory interface
 * @export
 */
export var ProductGroupApiFactory = function (configuration, basePath, axios) {
    return {
        /**
         *
         * @summary null
         * @param {ProductGroupFormAdd} productGroupFormAdd
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productGroupAdd: function (productGroupFormAdd, options) {
            return ProductGroupApiFp(configuration).productGroupAdd(productGroupFormAdd, options)(axios, basePath);
        },
        /**
         *
         * @summary 商品グループ削除
         * @param {Array<object>} requestBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productGroupDelete: function (requestBody, options) {
            return ProductGroupApiFp(configuration).productGroupDelete(requestBody, options)(axios, basePath);
        },
        /**
         *
         * @summary 商品グループダウンロード
         * @param {InlineObject3} [inlineObject3]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productGroupDownload: function (inlineObject3, options) {
            return ProductGroupApiFp(configuration).productGroupDownload(inlineObject3, options)(axios, basePath);
        },
        /**
         *
         * @summary null
         * @param {ProductGroupFormEdit} productGroupFormEdit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productGroupEdit: function (productGroupFormEdit, options) {
            return ProductGroupApiFp(configuration).productGroupEdit(productGroupFormEdit, options)(axios, basePath);
        },
        /**
         *
         * @summary 商品グループ詳細
         * @param {number} id 対象のID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productGroupJanDetail: function (id, options) {
            return ProductGroupApiFp(configuration).productGroupJanDetail(id, options)(axios, basePath);
        },
        /**
         *
         * @summary null
         * @param {number} [pageNo] 表示するページ数
         * @param {number} [pageSize] ページ内に表示するリストの数。0の場合は全件取得する
         * @param {string} [sortField] ソート対象名
         * @param {string} [sortType] 昇順、降順(\&quot;-\&quot;:昇順、省略時:降順)
         * @param {string} [freeword] フリーワード検索
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productGroupList: function (pageNo, pageSize, sortField, sortType, freeword, options) {
            return ProductGroupApiFp(configuration).productGroupList(pageNo, pageSize, sortField, sortType, freeword, options)(axios, basePath);
        },
        /**
         *
         * @summary 商品グループ詳細
         * @param {number} id 対象のID
         * @param {string} productAreaCode 対象の商品エリアコード
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productGroupProductDetail: function (id, productAreaCode, options) {
            return ProductGroupApiFp(configuration).productGroupProductDetail(id, productAreaCode, options)(axios, basePath);
        },
    };
};
/**
 * ProductGroupApi - object-oriented interface
 * @export
 * @class ProductGroupApi
 * @extends {BaseAPI}
 */
var ProductGroupApi = /** @class */ (function (_super) {
    __extends(ProductGroupApi, _super);
    function ProductGroupApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary null
     * @param {ProductGroupFormAdd} productGroupFormAdd
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductGroupApi
     */
    ProductGroupApi.prototype.productGroupAdd = function (productGroupFormAdd, options) {
        return ProductGroupApiFp(this.configuration).productGroupAdd(productGroupFormAdd, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary 商品グループ削除
     * @param {Array<object>} requestBody
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductGroupApi
     */
    ProductGroupApi.prototype.productGroupDelete = function (requestBody, options) {
        return ProductGroupApiFp(this.configuration).productGroupDelete(requestBody, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary 商品グループダウンロード
     * @param {InlineObject3} [inlineObject3]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductGroupApi
     */
    ProductGroupApi.prototype.productGroupDownload = function (inlineObject3, options) {
        return ProductGroupApiFp(this.configuration).productGroupDownload(inlineObject3, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary null
     * @param {ProductGroupFormEdit} productGroupFormEdit
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductGroupApi
     */
    ProductGroupApi.prototype.productGroupEdit = function (productGroupFormEdit, options) {
        return ProductGroupApiFp(this.configuration).productGroupEdit(productGroupFormEdit, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary 商品グループ詳細
     * @param {number} id 対象のID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductGroupApi
     */
    ProductGroupApi.prototype.productGroupJanDetail = function (id, options) {
        return ProductGroupApiFp(this.configuration).productGroupJanDetail(id, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary null
     * @param {number} [pageNo] 表示するページ数
     * @param {number} [pageSize] ページ内に表示するリストの数。0の場合は全件取得する
     * @param {string} [sortField] ソート対象名
     * @param {string} [sortType] 昇順、降順(\&quot;-\&quot;:昇順、省略時:降順)
     * @param {string} [freeword] フリーワード検索
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductGroupApi
     */
    ProductGroupApi.prototype.productGroupList = function (pageNo, pageSize, sortField, sortType, freeword, options) {
        return ProductGroupApiFp(this.configuration).productGroupList(pageNo, pageSize, sortField, sortType, freeword, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary 商品グループ詳細
     * @param {number} id 対象のID
     * @param {string} productAreaCode 対象の商品エリアコード
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductGroupApi
     */
    ProductGroupApi.prototype.productGroupProductDetail = function (id, productAreaCode, options) {
        return ProductGroupApiFp(this.configuration).productGroupProductDetail(id, productAreaCode, options)(this.axios, this.basePath);
    };
    return ProductGroupApi;
}(BaseAPI));
export { ProductGroupApi };
/**
 * ProductSearchApi - axios parameter creator
 * @export
 */
export var ProductSearchApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary jan商品取得（商品カテゴリ）
         * @param {InlineObject16} [inlineObject16]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productSearchCategory: function (inlineObject16, options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/product_search/category";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'POST' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("InlineObject16" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(inlineObject16 !== undefined ? inlineObject16 : {}) : (inlineObject16 || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary jan商品取得（カテゴリーグループ）
         * @param {InlineObject17} [inlineObject17]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productSearchCategoryGroup: function (inlineObject17, options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/product_search/category_group";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'POST' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("InlineObject17" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(inlineObject17 !== undefined ? inlineObject17 : {}) : (inlineObject17 || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary jan商品取得（コード）
         * @param {InlineObject18} [inlineObject18]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productSearchCode: function (inlineObject18, options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/product_search/code";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'POST' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("InlineObject18" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(inlineObject18 !== undefined ? inlineObject18 : {}) : (inlineObject18 || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary jan商品取得（商品コードファイルアップロード）
         * @param {any} [file]
         * @param {string} [analyzeTargetCode]
         * @param {number} [contractFlag] 1:自社商品から選択 2:契約カテゴリーから選択 3:対象商品検索
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productSearchFile: function (file, analyzeTargetCode, contractFlag, options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/product_search/file";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'POST' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            var localVarFormParams = new FormData();
            if (file !== undefined) {
                localVarFormParams.append('file', file);
            }
            if (analyzeTargetCode !== undefined) {
                localVarFormParams.append('analyze_target_code', analyzeTargetCode);
            }
            if (contractFlag !== undefined) {
                localVarFormParams.append('contract_flag', contractFlag);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            localVarRequestOptions.data = localVarFormParams;
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary jan商品取得（フリーワード）
         * @param {InlineObject20} [inlineObject20]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productSearchFreeword: function (inlineObject20, options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/product_search/freeword";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'POST' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("InlineObject20" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(inlineObject20 !== undefined ? inlineObject20 : {}) : (inlineObject20 || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary jan商品取得（グループ）
         * @param {InlineObject21} [inlineObject21]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productSearchGroup: function (inlineObject21, options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/product_search/group";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'POST' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("InlineObject21" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(inlineObject21 !== undefined ? inlineObject21 : {}) : (inlineObject21 || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary jan商品取得（名称）
         * @param {InlineObject22} [inlineObject22]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productSearchName: function (inlineObject22, options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/product_search/name";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'POST' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("InlineObject22" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(inlineObject22 !== undefined ? inlineObject22 : {}) : (inlineObject22 || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * ProductSearchApi - functional programming interface
 * @export
 */
export var ProductSearchApiFp = function (configuration) {
    return {
        /**
         *
         * @summary jan商品取得（商品カテゴリ）
         * @param {InlineObject16} [inlineObject16]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productSearchCategory: function (inlineObject16, options) {
            var localVarAxiosArgs = ProductSearchApiAxiosParamCreator(configuration).productSearchCategory(inlineObject16, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary jan商品取得（カテゴリーグループ）
         * @param {InlineObject17} [inlineObject17]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productSearchCategoryGroup: function (inlineObject17, options) {
            var localVarAxiosArgs = ProductSearchApiAxiosParamCreator(configuration).productSearchCategoryGroup(inlineObject17, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary jan商品取得（コード）
         * @param {InlineObject18} [inlineObject18]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productSearchCode: function (inlineObject18, options) {
            var localVarAxiosArgs = ProductSearchApiAxiosParamCreator(configuration).productSearchCode(inlineObject18, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary jan商品取得（商品コードファイルアップロード）
         * @param {any} [file]
         * @param {string} [analyzeTargetCode]
         * @param {number} [contractFlag] 1:自社商品から選択 2:契約カテゴリーから選択 3:対象商品検索
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productSearchFile: function (file, analyzeTargetCode, contractFlag, options) {
            var localVarAxiosArgs = ProductSearchApiAxiosParamCreator(configuration).productSearchFile(file, analyzeTargetCode, contractFlag, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary jan商品取得（フリーワード）
         * @param {InlineObject20} [inlineObject20]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productSearchFreeword: function (inlineObject20, options) {
            var localVarAxiosArgs = ProductSearchApiAxiosParamCreator(configuration).productSearchFreeword(inlineObject20, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary jan商品取得（グループ）
         * @param {InlineObject21} [inlineObject21]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productSearchGroup: function (inlineObject21, options) {
            var localVarAxiosArgs = ProductSearchApiAxiosParamCreator(configuration).productSearchGroup(inlineObject21, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary jan商品取得（名称）
         * @param {InlineObject22} [inlineObject22]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productSearchName: function (inlineObject22, options) {
            var localVarAxiosArgs = ProductSearchApiAxiosParamCreator(configuration).productSearchName(inlineObject22, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
    };
};
/**
 * ProductSearchApi - factory interface
 * @export
 */
export var ProductSearchApiFactory = function (configuration, basePath, axios) {
    return {
        /**
         *
         * @summary jan商品取得（商品カテゴリ）
         * @param {InlineObject16} [inlineObject16]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productSearchCategory: function (inlineObject16, options) {
            return ProductSearchApiFp(configuration).productSearchCategory(inlineObject16, options)(axios, basePath);
        },
        /**
         *
         * @summary jan商品取得（カテゴリーグループ）
         * @param {InlineObject17} [inlineObject17]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productSearchCategoryGroup: function (inlineObject17, options) {
            return ProductSearchApiFp(configuration).productSearchCategoryGroup(inlineObject17, options)(axios, basePath);
        },
        /**
         *
         * @summary jan商品取得（コード）
         * @param {InlineObject18} [inlineObject18]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productSearchCode: function (inlineObject18, options) {
            return ProductSearchApiFp(configuration).productSearchCode(inlineObject18, options)(axios, basePath);
        },
        /**
         *
         * @summary jan商品取得（商品コードファイルアップロード）
         * @param {any} [file]
         * @param {string} [analyzeTargetCode]
         * @param {number} [contractFlag] 1:自社商品から選択 2:契約カテゴリーから選択 3:対象商品検索
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productSearchFile: function (file, analyzeTargetCode, contractFlag, options) {
            return ProductSearchApiFp(configuration).productSearchFile(file, analyzeTargetCode, contractFlag, options)(axios, basePath);
        },
        /**
         *
         * @summary jan商品取得（フリーワード）
         * @param {InlineObject20} [inlineObject20]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productSearchFreeword: function (inlineObject20, options) {
            return ProductSearchApiFp(configuration).productSearchFreeword(inlineObject20, options)(axios, basePath);
        },
        /**
         *
         * @summary jan商品取得（グループ）
         * @param {InlineObject21} [inlineObject21]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productSearchGroup: function (inlineObject21, options) {
            return ProductSearchApiFp(configuration).productSearchGroup(inlineObject21, options)(axios, basePath);
        },
        /**
         *
         * @summary jan商品取得（名称）
         * @param {InlineObject22} [inlineObject22]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productSearchName: function (inlineObject22, options) {
            return ProductSearchApiFp(configuration).productSearchName(inlineObject22, options)(axios, basePath);
        },
    };
};
/**
 * ProductSearchApi - object-oriented interface
 * @export
 * @class ProductSearchApi
 * @extends {BaseAPI}
 */
var ProductSearchApi = /** @class */ (function (_super) {
    __extends(ProductSearchApi, _super);
    function ProductSearchApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary jan商品取得（商品カテゴリ）
     * @param {InlineObject16} [inlineObject16]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductSearchApi
     */
    ProductSearchApi.prototype.productSearchCategory = function (inlineObject16, options) {
        return ProductSearchApiFp(this.configuration).productSearchCategory(inlineObject16, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary jan商品取得（カテゴリーグループ）
     * @param {InlineObject17} [inlineObject17]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductSearchApi
     */
    ProductSearchApi.prototype.productSearchCategoryGroup = function (inlineObject17, options) {
        return ProductSearchApiFp(this.configuration).productSearchCategoryGroup(inlineObject17, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary jan商品取得（コード）
     * @param {InlineObject18} [inlineObject18]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductSearchApi
     */
    ProductSearchApi.prototype.productSearchCode = function (inlineObject18, options) {
        return ProductSearchApiFp(this.configuration).productSearchCode(inlineObject18, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary jan商品取得（商品コードファイルアップロード）
     * @param {any} [file]
     * @param {string} [analyzeTargetCode]
     * @param {number} [contractFlag] 1:自社商品から選択 2:契約カテゴリーから選択 3:対象商品検索
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductSearchApi
     */
    ProductSearchApi.prototype.productSearchFile = function (file, analyzeTargetCode, contractFlag, options) {
        return ProductSearchApiFp(this.configuration).productSearchFile(file, analyzeTargetCode, contractFlag, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary jan商品取得（フリーワード）
     * @param {InlineObject20} [inlineObject20]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductSearchApi
     */
    ProductSearchApi.prototype.productSearchFreeword = function (inlineObject20, options) {
        return ProductSearchApiFp(this.configuration).productSearchFreeword(inlineObject20, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary jan商品取得（グループ）
     * @param {InlineObject21} [inlineObject21]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductSearchApi
     */
    ProductSearchApi.prototype.productSearchGroup = function (inlineObject21, options) {
        return ProductSearchApiFp(this.configuration).productSearchGroup(inlineObject21, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary jan商品取得（名称）
     * @param {InlineObject22} [inlineObject22]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductSearchApi
     */
    ProductSearchApi.prototype.productSearchName = function (inlineObject22, options) {
        return ProductSearchApiFp(this.configuration).productSearchName(inlineObject22, options)(this.axios, this.basePath);
    };
    return ProductSearchApi;
}(BaseAPI));
export { ProductSearchApi };
/**
 * ReservationApi - axios parameter creator
 * @export
 */
export var ReservationApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary 分析予約削除
         * @param {Array<object>} requestBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reservationDelete: function (requestBody, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'requestBody' is not null or undefined
            if (requestBody === null || requestBody === undefined) {
                throw new RequiredError('requestBody', 'Required parameter requestBody was null or undefined when calling reservationDelete.');
            }
            var localVarPath = "/reservation";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'DELETE' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("Array&lt;object&gt;" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(requestBody !== undefined ? requestBody : {}) : (requestBody || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 分析予約詳細
         * @param {number} id 対象のID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reservationDetail: function (id, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id', 'Required parameter id was null or undefined when calling reservationDetail.');
            }
            var localVarPath = "/reservation/{id}"
                .replace("{" + "id" + "}", encodeURIComponent(String(id)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 分析予約更新
         * @param {ReservationEditModel} reservationEditModel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reservationEdit: function (reservationEditModel, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'reservationEditModel' is not null or undefined
            if (reservationEditModel === null || reservationEditModel === undefined) {
                throw new RequiredError('reservationEditModel', 'Required parameter reservationEditModel was null or undefined when calling reservationEdit.');
            }
            var localVarPath = "/reservation";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'PUT' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("ReservationEditModel" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(reservationEditModel !== undefined ? reservationEditModel : {}) : (reservationEditModel || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 分析予約一覧
         * @param {number} [pageNo] 表示するページ数
         * @param {number} [pageSize] ページ内に表示するリストの数。0の場合は全件取得する
         * @param {string} [sortField] ソート対象名
         * @param {string} [sortType] 昇順、降順(\&quot;-\&quot;:昇順、省略時:降順)
         * @param {string} [freeword] フリーワード検索
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reservationList: function (pageNo, pageSize, sortField, sortType, freeword, options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/reservation/list";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (pageNo !== undefined) {
                localVarQueryParameter['page_no'] = pageNo;
            }
            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }
            if (sortField !== undefined) {
                localVarQueryParameter['sort_field'] = sortField;
            }
            if (sortType !== undefined) {
                localVarQueryParameter['sort_type'] = sortType;
            }
            if (freeword !== undefined) {
                localVarQueryParameter['freeword'] = freeword;
            }
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * ReservationApi - functional programming interface
 * @export
 */
export var ReservationApiFp = function (configuration) {
    return {
        /**
         *
         * @summary 分析予約削除
         * @param {Array<object>} requestBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reservationDelete: function (requestBody, options) {
            var localVarAxiosArgs = ReservationApiAxiosParamCreator(configuration).reservationDelete(requestBody, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary 分析予約詳細
         * @param {number} id 対象のID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reservationDetail: function (id, options) {
            var localVarAxiosArgs = ReservationApiAxiosParamCreator(configuration).reservationDetail(id, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary 分析予約更新
         * @param {ReservationEditModel} reservationEditModel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reservationEdit: function (reservationEditModel, options) {
            var localVarAxiosArgs = ReservationApiAxiosParamCreator(configuration).reservationEdit(reservationEditModel, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary 分析予約一覧
         * @param {number} [pageNo] 表示するページ数
         * @param {number} [pageSize] ページ内に表示するリストの数。0の場合は全件取得する
         * @param {string} [sortField] ソート対象名
         * @param {string} [sortType] 昇順、降順(\&quot;-\&quot;:昇順、省略時:降順)
         * @param {string} [freeword] フリーワード検索
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reservationList: function (pageNo, pageSize, sortField, sortType, freeword, options) {
            var localVarAxiosArgs = ReservationApiAxiosParamCreator(configuration).reservationList(pageNo, pageSize, sortField, sortType, freeword, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
    };
};
/**
 * ReservationApi - factory interface
 * @export
 */
export var ReservationApiFactory = function (configuration, basePath, axios) {
    return {
        /**
         *
         * @summary 分析予約削除
         * @param {Array<object>} requestBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reservationDelete: function (requestBody, options) {
            return ReservationApiFp(configuration).reservationDelete(requestBody, options)(axios, basePath);
        },
        /**
         *
         * @summary 分析予約詳細
         * @param {number} id 対象のID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reservationDetail: function (id, options) {
            return ReservationApiFp(configuration).reservationDetail(id, options)(axios, basePath);
        },
        /**
         *
         * @summary 分析予約更新
         * @param {ReservationEditModel} reservationEditModel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reservationEdit: function (reservationEditModel, options) {
            return ReservationApiFp(configuration).reservationEdit(reservationEditModel, options)(axios, basePath);
        },
        /**
         *
         * @summary 分析予約一覧
         * @param {number} [pageNo] 表示するページ数
         * @param {number} [pageSize] ページ内に表示するリストの数。0の場合は全件取得する
         * @param {string} [sortField] ソート対象名
         * @param {string} [sortType] 昇順、降順(\&quot;-\&quot;:昇順、省略時:降順)
         * @param {string} [freeword] フリーワード検索
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reservationList: function (pageNo, pageSize, sortField, sortType, freeword, options) {
            return ReservationApiFp(configuration).reservationList(pageNo, pageSize, sortField, sortType, freeword, options)(axios, basePath);
        },
    };
};
/**
 * ReservationApi - object-oriented interface
 * @export
 * @class ReservationApi
 * @extends {BaseAPI}
 */
var ReservationApi = /** @class */ (function (_super) {
    __extends(ReservationApi, _super);
    function ReservationApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary 分析予約削除
     * @param {Array<object>} requestBody
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReservationApi
     */
    ReservationApi.prototype.reservationDelete = function (requestBody, options) {
        return ReservationApiFp(this.configuration).reservationDelete(requestBody, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary 分析予約詳細
     * @param {number} id 対象のID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReservationApi
     */
    ReservationApi.prototype.reservationDetail = function (id, options) {
        return ReservationApiFp(this.configuration).reservationDetail(id, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary 分析予約更新
     * @param {ReservationEditModel} reservationEditModel
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReservationApi
     */
    ReservationApi.prototype.reservationEdit = function (reservationEditModel, options) {
        return ReservationApiFp(this.configuration).reservationEdit(reservationEditModel, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary 分析予約一覧
     * @param {number} [pageNo] 表示するページ数
     * @param {number} [pageSize] ページ内に表示するリストの数。0の場合は全件取得する
     * @param {string} [sortField] ソート対象名
     * @param {string} [sortType] 昇順、降順(\&quot;-\&quot;:昇順、省略時:降順)
     * @param {string} [freeword] フリーワード検索
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReservationApi
     */
    ReservationApi.prototype.reservationList = function (pageNo, pageSize, sortField, sortType, freeword, options) {
        return ReservationApiFp(this.configuration).reservationList(pageNo, pageSize, sortField, sortType, freeword, options)(this.axios, this.basePath);
    };
    return ReservationApi;
}(BaseAPI));
export { ReservationApi };
/**
 * ResultApi - axios parameter creator
 * @export
 */
export var ResultApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary 分析結果 CSVダウンロード
         * @param {InlineObject35} [inlineObject35]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resultCsv: function (inlineObject35, options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/result/csv";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'POST' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("InlineObject35" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(inlineObject35 !== undefined ? inlineObject35 : {}) : (inlineObject35 || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 分析結果 買上明細集計(ID-POS)(IF00001)
         * @param {InlineObject37} [inlineObject37]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resultDataIf00001: function (inlineObject37, options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/result/data/IF00001";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'POST' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("InlineObject37" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(inlineObject37 !== undefined ? inlineObject37 : {}) : (inlineObject37 || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 分析結果 性年代別購入者分析(IF00002)
         * @param {InlineObject38} [inlineObject38]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resultDataIf00002: function (inlineObject38, options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/result/data/IF00002";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'POST' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("InlineObject38" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(inlineObject38 !== undefined ? inlineObject38 : {}) : (inlineObject38 || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 分析結果 ABCL分析(IF00003)
         * @param {InlineObject39} [inlineObject39]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resultDataIf00003: function (inlineObject39, options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/result/data/IF00003";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'POST' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("InlineObject39" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(inlineObject39 !== undefined ? inlineObject39 : {}) : (inlineObject39 || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 分析結果 トライアルリピート分析(IF00004)
         * @param {InlineObject40} [inlineObject40]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resultDataIf00004: function (inlineObject40, options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/result/data/IF00004";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'POST' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("InlineObject40" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(inlineObject40 !== undefined ? inlineObject40 : {}) : (inlineObject40 || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 分析結果 トレンド分析(IF00005)
         * @param {InlineObject41} [inlineObject41]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resultDataIf00005: function (inlineObject41, options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/result/data/IF00005";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'POST' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("InlineObject41" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(inlineObject41 !== undefined ? inlineObject41 : {}) : (inlineObject41 || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 分析結果 バスケット分析(IF00006)
         * @param {InlineObject42} [inlineObject42]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resultDataIf00006: function (inlineObject42, options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/result/data/IF00006";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'POST' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("InlineObject42" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(inlineObject42 !== undefined ? inlineObject42 : {}) : (inlineObject42 || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 分析結果 併買分析(IF00007)
         * @param {InlineObject43} [inlineObject43]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resultDataIf00007: function (inlineObject43, options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/result/data/IF00007";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'POST' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("InlineObject43" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(inlineObject43 !== undefined ? inlineObject43 : {}) : (inlineObject43 || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 分析結果 顧客構造図(IF00030)
         * @param {InlineObject43} [inlineObject43]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resultDataIf00030: function (inlineObject43, options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/result/data/IF00030";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'POST' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("InlineObject43" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(inlineObject43 !== undefined ? inlineObject43 : {}) : (inlineObject43 || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 分析結果 カード会員サマリ(IF00008)
         * @param {InlineObject44} [inlineObject44]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resultDataIf00008: function (inlineObject44, options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/result/data/IF00008";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'POST' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("InlineObject44" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(inlineObject44 !== undefined ? inlineObject44 : {}) : (inlineObject44 || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 分析結果 買上明細集計(POS)(IF00009)
         * @param {InlineObject45} [inlineObject45]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resultDataIf00009: function (inlineObject45, options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/result/data/IF00009";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'POST' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("InlineObject45" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(inlineObject45 !== undefined ? inlineObject45 : {}) : (inlineObject45 || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 分析結果 商品別売上分析(IF00010)
         * @param {InlineObject46} [inlineObject46]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resultDataIf00010: function (inlineObject46, options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/result/data/IF00010";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'POST' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("InlineObject46" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(inlineObject46 !== undefined ? inlineObject46 : {}) : (inlineObject46 || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 分析結果 ABC分析(IF00011)
         * @param {InlineObject47} [inlineObject47]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resultDataIf00011: function (inlineObject47, options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/result/data/IF00011";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'POST' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("InlineObject47" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(inlineObject47 !== undefined ? inlineObject47 : {}) : (inlineObject47 || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 分析結果 分類商品推移表(IF00012)
         * @param {InlineObject48} [inlineObject48]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resultDataIf00012: function (inlineObject48, options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/result/data/IF00012";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'POST' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("InlineObject48" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(inlineObject48 !== undefined ? inlineObject48 : {}) : (inlineObject48 || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 分析結果 商品別自社シェア分析(IF00013)
         * @param {InlineObject49} [inlineObject49]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resultDataIf00013: function (inlineObject49, options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/result/data/IF00013";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'POST' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("InlineObject49" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(inlineObject49 !== undefined ? inlineObject49 : {}) : (inlineObject49 || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 分析結果 明細ダウンロード(IF00014)
         * @param {InlineObject50} [inlineObject50]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resultDataIf00014: function (inlineObject50, options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/result/data/IF00014";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'POST' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("InlineObject50" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(inlineObject50 !== undefined ? inlineObject50 : {}) : (inlineObject50 || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 分析結果 マスタダウンロード(IF00015)
         * @param {InlineObject51} [inlineObject51]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resultDataIf00015: function (inlineObject51, options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/result/data/IF00015";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'POST' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("InlineObject51" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(inlineObject51 !== undefined ? inlineObject51 : {}) : (inlineObject51 || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 分析結果 任意ダウンロード(ID-POS)(IF00016)
         * @param {InlineObject52} [inlineObject52]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resultDataIf00016: function (inlineObject52, options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/result/data/IF00016";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'POST' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("InlineObject52" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(inlineObject52 !== undefined ? inlineObject52 : {}) : (inlineObject52 || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 分析結果 任意ダウンロード(POS)(IF00017)
         * @param {InlineObject53} [inlineObject53]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resultDataIf00017: function (inlineObject53, options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/result/data/IF00017";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'POST' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("InlineObject53" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(inlineObject53 !== undefined ? inlineObject53 : {}) : (inlineObject53 || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 分析結果 Excelダウンロード
         * @param {InlineObject36} [inlineObject36]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resultExcel: function (inlineObject36, options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/result/excel";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'POST' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("InlineObject36" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(inlineObject36 !== undefined ? inlineObject36 : {}) : (inlineObject36 || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 分析結果 基準商品CSVダウンロード
         * @param {InlineObject33} [inlineObject33]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resultItemBasecsv: function (inlineObject33, options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/result/item_base";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'POST' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("InlineObject33" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(inlineObject33 !== undefined ? inlineObject33 : {}) : (inlineObject33 || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 分析結果 対象商品CSVダウンロード
         * @param {InlineObject34} [inlineObject34]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resultItemTargetcsv: function (inlineObject34, options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/result/item_target";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'POST' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("InlineObject34" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(inlineObject34 !== undefined ? inlineObject34 : {}) : (inlineObject34 || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * ResultApi - functional programming interface
 * @export
 */
export var ResultApiFp = function (configuration) {
    return {
        /**
         *
         * @summary 分析結果 CSVダウンロード
         * @param {InlineObject35} [inlineObject35]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resultCsv: function (inlineObject35, options) {
            var localVarAxiosArgs = ResultApiAxiosParamCreator(configuration).resultCsv(inlineObject35, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary 分析結果 買上明細集計(ID-POS)(IF00001)
         * @param {InlineObject37} [inlineObject37]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resultDataIf00001: function (inlineObject37, options) {
            var localVarAxiosArgs = ResultApiAxiosParamCreator(configuration).resultDataIf00001(inlineObject37, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary 分析結果 性年代別購入者分析(IF00002)
         * @param {InlineObject38} [inlineObject38]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resultDataIf00002: function (inlineObject38, options) {
            var localVarAxiosArgs = ResultApiAxiosParamCreator(configuration).resultDataIf00002(inlineObject38, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary 分析結果 ABCL分析(IF00003)
         * @param {InlineObject39} [inlineObject39]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resultDataIf00003: function (inlineObject39, options) {
            var localVarAxiosArgs = ResultApiAxiosParamCreator(configuration).resultDataIf00003(inlineObject39, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary 分析結果 トライアルリピート分析(IF00004)
         * @param {InlineObject40} [inlineObject40]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resultDataIf00004: function (inlineObject40, options) {
            var localVarAxiosArgs = ResultApiAxiosParamCreator(configuration).resultDataIf00004(inlineObject40, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary 分析結果 トレンド分析(IF00005)
         * @param {InlineObject41} [inlineObject41]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resultDataIf00005: function (inlineObject41, options) {
            var localVarAxiosArgs = ResultApiAxiosParamCreator(configuration).resultDataIf00005(inlineObject41, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary 分析結果 バスケット分析(IF00006)
         * @param {InlineObject42} [inlineObject42]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resultDataIf00006: function (inlineObject42, options) {
            var localVarAxiosArgs = ResultApiAxiosParamCreator(configuration).resultDataIf00006(inlineObject42, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary 分析結果 併買分析(IF00007)
         * @param {InlineObject43} [inlineObject43]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resultDataIf00007: function (inlineObject43, options) {
            var localVarAxiosArgs = ResultApiAxiosParamCreator(configuration).resultDataIf00007(inlineObject43, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary 分析結果 顧客構造図(IF00030)
         * @param {InlineObject43} [inlineObject43]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resultDataIf00030: function (inlineObject43, options) {
            var localVarAxiosArgs = ResultApiAxiosParamCreator(configuration).resultDataIf00030(inlineObject43, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary 分析結果 カード会員サマリ(IF00008)
         * @param {InlineObject44} [inlineObject44]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resultDataIf00008: function (inlineObject44, options) {
            var localVarAxiosArgs = ResultApiAxiosParamCreator(configuration).resultDataIf00008(inlineObject44, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary 分析結果 買上明細集計(POS)(IF00009)
         * @param {InlineObject45} [inlineObject45]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resultDataIf00009: function (inlineObject45, options) {
            var localVarAxiosArgs = ResultApiAxiosParamCreator(configuration).resultDataIf00009(inlineObject45, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary 分析結果 商品別売上分析(IF00010)
         * @param {InlineObject46} [inlineObject46]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resultDataIf00010: function (inlineObject46, options) {
            var localVarAxiosArgs = ResultApiAxiosParamCreator(configuration).resultDataIf00010(inlineObject46, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary 分析結果 ABC分析(IF00011)
         * @param {InlineObject47} [inlineObject47]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resultDataIf00011: function (inlineObject47, options) {
            var localVarAxiosArgs = ResultApiAxiosParamCreator(configuration).resultDataIf00011(inlineObject47, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary 分析結果 分類商品推移表(IF00012)
         * @param {InlineObject48} [inlineObject48]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resultDataIf00012: function (inlineObject48, options) {
            var localVarAxiosArgs = ResultApiAxiosParamCreator(configuration).resultDataIf00012(inlineObject48, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary 分析結果 商品別自社シェア分析(IF00013)
         * @param {InlineObject49} [inlineObject49]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resultDataIf00013: function (inlineObject49, options) {
            var localVarAxiosArgs = ResultApiAxiosParamCreator(configuration).resultDataIf00013(inlineObject49, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary 分析結果 明細ダウンロード(IF00014)
         * @param {InlineObject50} [inlineObject50]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resultDataIf00014: function (inlineObject50, options) {
            var localVarAxiosArgs = ResultApiAxiosParamCreator(configuration).resultDataIf00014(inlineObject50, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary 分析結果 マスタダウンロード(IF00015)
         * @param {InlineObject51} [inlineObject51]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resultDataIf00015: function (inlineObject51, options) {
            var localVarAxiosArgs = ResultApiAxiosParamCreator(configuration).resultDataIf00015(inlineObject51, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary 分析結果 任意ダウンロード(ID-POS)(IF00016)
         * @param {InlineObject52} [inlineObject52]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resultDataIf00016: function (inlineObject52, options) {
            var localVarAxiosArgs = ResultApiAxiosParamCreator(configuration).resultDataIf00016(inlineObject52, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary 分析結果 任意ダウンロード(POS)(IF00017)
         * @param {InlineObject53} [inlineObject53]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resultDataIf00017: function (inlineObject53, options) {
            var localVarAxiosArgs = ResultApiAxiosParamCreator(configuration).resultDataIf00017(inlineObject53, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary 分析結果 Excelダウンロード
         * @param {InlineObject36} [inlineObject36]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resultExcel: function (inlineObject36, options) {
            var localVarAxiosArgs = ResultApiAxiosParamCreator(configuration).resultExcel(inlineObject36, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary 分析結果 基準商品CSVダウンロード
         * @param {InlineObject33} [inlineObject33]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resultItemBasecsv: function (inlineObject33, options) {
            var localVarAxiosArgs = ResultApiAxiosParamCreator(configuration).resultItemBasecsv(inlineObject33, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary 分析結果 対象商品CSVダウンロード
         * @param {InlineObject34} [inlineObject34]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resultItemTargetcsv: function (inlineObject34, options) {
            var localVarAxiosArgs = ResultApiAxiosParamCreator(configuration).resultItemTargetcsv(inlineObject34, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
    };
};
/**
 * ResultApi - factory interface
 * @export
 */
export var ResultApiFactory = function (configuration, basePath, axios) {
    return {
        /**
         *
         * @summary 分析結果 CSVダウンロード
         * @param {InlineObject35} [inlineObject35]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resultCsv: function (inlineObject35, options) {
            return ResultApiFp(configuration).resultCsv(inlineObject35, options)(axios, basePath);
        },
        /**
         *
         * @summary 分析結果 買上明細集計(ID-POS)(IF00001)
         * @param {InlineObject37} [inlineObject37]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resultDataIf00001: function (inlineObject37, options) {
            return ResultApiFp(configuration).resultDataIf00001(inlineObject37, options)(axios, basePath);
        },
        /**
         *
         * @summary 分析結果 性年代別購入者分析(IF00002)
         * @param {InlineObject38} [inlineObject38]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resultDataIf00002: function (inlineObject38, options) {
            return ResultApiFp(configuration).resultDataIf00002(inlineObject38, options)(axios, basePath);
        },
        /**
         *
         * @summary 分析結果 ABCL分析(IF00003)
         * @param {InlineObject39} [inlineObject39]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resultDataIf00003: function (inlineObject39, options) {
            return ResultApiFp(configuration).resultDataIf00003(inlineObject39, options)(axios, basePath);
        },
        /**
         *
         * @summary 分析結果 トライアルリピート分析(IF00004)
         * @param {InlineObject40} [inlineObject40]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resultDataIf00004: function (inlineObject40, options) {
            return ResultApiFp(configuration).resultDataIf00004(inlineObject40, options)(axios, basePath);
        },
        /**
         *
         * @summary 分析結果 トレンド分析(IF00005)
         * @param {InlineObject41} [inlineObject41]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resultDataIf00005: function (inlineObject41, options) {
            return ResultApiFp(configuration).resultDataIf00005(inlineObject41, options)(axios, basePath);
        },
        /**
         *
         * @summary 分析結果 バスケット分析(IF00006)
         * @param {InlineObject42} [inlineObject42]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resultDataIf00006: function (inlineObject42, options) {
            return ResultApiFp(configuration).resultDataIf00006(inlineObject42, options)(axios, basePath);
        },
        /**
         *
         * @summary 分析結果 併買分析(IF00007)
         * @param {InlineObject43} [inlineObject43]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resultDataIf00007: function (inlineObject43, options) {
            return ResultApiFp(configuration).resultDataIf00007(inlineObject43, options)(axios, basePath);
        },
        /**
         *
         * @summary 分析結果 顧客構造図(IF00030)
         * @param {InlineObject43} [inlineObject43]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resultDataIf00030: function (inlineObject43, options) {
            return ResultApiFp(configuration).resultDataIf00030(inlineObject43, options)(axios, basePath);
        },
        /**
         *
         * @summary 分析結果 カード会員サマリ(IF00008)
         * @param {InlineObject44} [inlineObject44]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resultDataIf00008: function (inlineObject44, options) {
            return ResultApiFp(configuration).resultDataIf00008(inlineObject44, options)(axios, basePath);
        },
        /**
         *
         * @summary 分析結果 買上明細集計(POS)(IF00009)
         * @param {InlineObject45} [inlineObject45]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resultDataIf00009: function (inlineObject45, options) {
            return ResultApiFp(configuration).resultDataIf00009(inlineObject45, options)(axios, basePath);
        },
        /**
         *
         * @summary 分析結果 商品別売上分析(IF00010)
         * @param {InlineObject46} [inlineObject46]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resultDataIf00010: function (inlineObject46, options) {
            return ResultApiFp(configuration).resultDataIf00010(inlineObject46, options)(axios, basePath);
        },
        /**
         *
         * @summary 分析結果 ABC分析(IF00011)
         * @param {InlineObject47} [inlineObject47]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resultDataIf00011: function (inlineObject47, options) {
            return ResultApiFp(configuration).resultDataIf00011(inlineObject47, options)(axios, basePath);
        },
        /**
         *
         * @summary 分析結果 分類商品推移表(IF00012)
         * @param {InlineObject48} [inlineObject48]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resultDataIf00012: function (inlineObject48, options) {
            return ResultApiFp(configuration).resultDataIf00012(inlineObject48, options)(axios, basePath);
        },
        /**
         *
         * @summary 分析結果 商品別自社シェア分析(IF00013)
         * @param {InlineObject49} [inlineObject49]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resultDataIf00013: function (inlineObject49, options) {
            return ResultApiFp(configuration).resultDataIf00013(inlineObject49, options)(axios, basePath);
        },
        /**
         *
         * @summary 分析結果 明細ダウンロード(IF00014)
         * @param {InlineObject50} [inlineObject50]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resultDataIf00014: function (inlineObject50, options) {
            return ResultApiFp(configuration).resultDataIf00014(inlineObject50, options)(axios, basePath);
        },
        /**
         *
         * @summary 分析結果 マスタダウンロード(IF00015)
         * @param {InlineObject51} [inlineObject51]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resultDataIf00015: function (inlineObject51, options) {
            return ResultApiFp(configuration).resultDataIf00015(inlineObject51, options)(axios, basePath);
        },
        /**
         *
         * @summary 分析結果 任意ダウンロード(ID-POS)(IF00016)
         * @param {InlineObject52} [inlineObject52]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resultDataIf00016: function (inlineObject52, options) {
            return ResultApiFp(configuration).resultDataIf00016(inlineObject52, options)(axios, basePath);
        },
        /**
         *
         * @summary 分析結果 任意ダウンロード(POS)(IF00017)
         * @param {InlineObject53} [inlineObject53]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resultDataIf00017: function (inlineObject53, options) {
            return ResultApiFp(configuration).resultDataIf00017(inlineObject53, options)(axios, basePath);
        },
        /**
         *
         * @summary 分析結果 Excelダウンロード
         * @param {InlineObject36} [inlineObject36]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resultExcel: function (inlineObject36, options) {
            return ResultApiFp(configuration).resultExcel(inlineObject36, options)(axios, basePath);
        },
        /**
         *
         * @summary 分析結果 基準商品CSVダウンロード
         * @param {InlineObject33} [inlineObject33]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resultItemBasecsv: function (inlineObject33, options) {
            return ResultApiFp(configuration).resultItemBasecsv(inlineObject33, options)(axios, basePath);
        },
        /**
         *
         * @summary 分析結果 対象商品CSVダウンロード
         * @param {InlineObject34} [inlineObject34]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resultItemTargetcsv: function (inlineObject34, options) {
            return ResultApiFp(configuration).resultItemTargetcsv(inlineObject34, options)(axios, basePath);
        },
    };
};
/**
 * ResultApi - object-oriented interface
 * @export
 * @class ResultApi
 * @extends {BaseAPI}
 */
var ResultApi = /** @class */ (function (_super) {
    __extends(ResultApi, _super);
    function ResultApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary 分析結果 CSVダウンロード
     * @param {InlineObject35} [inlineObject35]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResultApi
     */
    ResultApi.prototype.resultCsv = function (inlineObject35, options) {
        return ResultApiFp(this.configuration).resultCsv(inlineObject35, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary 分析結果 買上明細集計(ID-POS)(IF00001)
     * @param {InlineObject37} [inlineObject37]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResultApi
     */
    ResultApi.prototype.resultDataIf00001 = function (inlineObject37, options) {
        return ResultApiFp(this.configuration).resultDataIf00001(inlineObject37, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary 分析結果 性年代別購入者分析(IF00002)
     * @param {InlineObject38} [inlineObject38]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResultApi
     */
    ResultApi.prototype.resultDataIf00002 = function (inlineObject38, options) {
        return ResultApiFp(this.configuration).resultDataIf00002(inlineObject38, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary 分析結果 ABCL分析(IF00003)
     * @param {InlineObject39} [inlineObject39]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResultApi
     */
    ResultApi.prototype.resultDataIf00003 = function (inlineObject39, options) {
        return ResultApiFp(this.configuration).resultDataIf00003(inlineObject39, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary 分析結果 トライアルリピート分析(IF00004)
     * @param {InlineObject40} [inlineObject40]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResultApi
     */
    ResultApi.prototype.resultDataIf00004 = function (inlineObject40, options) {
        return ResultApiFp(this.configuration).resultDataIf00004(inlineObject40, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary 分析結果 トレンド分析(IF00005)
     * @param {InlineObject41} [inlineObject41]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResultApi
     */
    ResultApi.prototype.resultDataIf00005 = function (inlineObject41, options) {
        return ResultApiFp(this.configuration).resultDataIf00005(inlineObject41, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary 分析結果 バスケット分析(IF00006)
     * @param {InlineObject42} [inlineObject42]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResultApi
     */
    ResultApi.prototype.resultDataIf00006 = function (inlineObject42, options) {
        return ResultApiFp(this.configuration).resultDataIf00006(inlineObject42, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary 分析結果 併買分析(IF00007)
     * @param {InlineObject43} [inlineObject43]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResultApi
     */
    ResultApi.prototype.resultDataIf00007 = function (inlineObject43, options) {
        return ResultApiFp(this.configuration).resultDataIf00007(inlineObject43, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary 分析結果 顧客構造図(IF00030)
     * @param {InlineObject43} [inlineObject43]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResultApi
     */
    ResultApi.prototype.resultDataIf00030 = function (inlineObject43, options) {
        return ResultApiFp(this.configuration).resultDataIf00030(inlineObject43, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary 分析結果 カード会員サマリ(IF00008)
     * @param {InlineObject44} [inlineObject44]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResultApi
     */
    ResultApi.prototype.resultDataIf00008 = function (inlineObject44, options) {
        return ResultApiFp(this.configuration).resultDataIf00008(inlineObject44, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary 分析結果 買上明細集計(POS)(IF00009)
     * @param {InlineObject45} [inlineObject45]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResultApi
     */
    ResultApi.prototype.resultDataIf00009 = function (inlineObject45, options) {
        return ResultApiFp(this.configuration).resultDataIf00009(inlineObject45, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary 分析結果 商品別売上分析(IF00010)
     * @param {InlineObject46} [inlineObject46]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResultApi
     */
    ResultApi.prototype.resultDataIf00010 = function (inlineObject46, options) {
        return ResultApiFp(this.configuration).resultDataIf00010(inlineObject46, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary 分析結果 ABC分析(IF00011)
     * @param {InlineObject47} [inlineObject47]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResultApi
     */
    ResultApi.prototype.resultDataIf00011 = function (inlineObject47, options) {
        return ResultApiFp(this.configuration).resultDataIf00011(inlineObject47, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary 分析結果 分類商品推移表(IF00012)
     * @param {InlineObject48} [inlineObject48]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResultApi
     */
    ResultApi.prototype.resultDataIf00012 = function (inlineObject48, options) {
        return ResultApiFp(this.configuration).resultDataIf00012(inlineObject48, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary 分析結果 商品別自社シェア分析(IF00013)
     * @param {InlineObject49} [inlineObject49]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResultApi
     */
    ResultApi.prototype.resultDataIf00013 = function (inlineObject49, options) {
        return ResultApiFp(this.configuration).resultDataIf00013(inlineObject49, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary 分析結果 明細ダウンロード(IF00014)
     * @param {InlineObject50} [inlineObject50]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResultApi
     */
    ResultApi.prototype.resultDataIf00014 = function (inlineObject50, options) {
        return ResultApiFp(this.configuration).resultDataIf00014(inlineObject50, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary 分析結果 マスタダウンロード(IF00015)
     * @param {InlineObject51} [inlineObject51]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResultApi
     */
    ResultApi.prototype.resultDataIf00015 = function (inlineObject51, options) {
        return ResultApiFp(this.configuration).resultDataIf00015(inlineObject51, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary 分析結果 任意ダウンロード(ID-POS)(IF00016)
     * @param {InlineObject52} [inlineObject52]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResultApi
     */
    ResultApi.prototype.resultDataIf00016 = function (inlineObject52, options) {
        return ResultApiFp(this.configuration).resultDataIf00016(inlineObject52, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary 分析結果 任意ダウンロード(POS)(IF00017)
     * @param {InlineObject53} [inlineObject53]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResultApi
     */
    ResultApi.prototype.resultDataIf00017 = function (inlineObject53, options) {
        return ResultApiFp(this.configuration).resultDataIf00017(inlineObject53, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary 分析結果 Excelダウンロード
     * @param {InlineObject36} [inlineObject36]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResultApi
     */
    ResultApi.prototype.resultExcel = function (inlineObject36, options) {
        return ResultApiFp(this.configuration).resultExcel(inlineObject36, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary 分析結果 基準商品CSVダウンロード
     * @param {InlineObject33} [inlineObject33]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResultApi
     */
    ResultApi.prototype.resultItemBasecsv = function (inlineObject33, options) {
        return ResultApiFp(this.configuration).resultItemBasecsv(inlineObject33, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary 分析結果 対象商品CSVダウンロード
     * @param {InlineObject34} [inlineObject34]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResultApi
     */
    ResultApi.prototype.resultItemTargetcsv = function (inlineObject34, options) {
        return ResultApiFp(this.configuration).resultItemTargetcsv(inlineObject34, options)(this.axios, this.basePath);
    };
    return ResultApi;
}(BaseAPI));
export { ResultApi };
/**
 * ShopAreaApi - axios parameter creator
 * @export
 */
export var ShopAreaApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary 店舗エリアマスタ一覧
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shopAreaList: function (options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/shop_area/list";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * ShopAreaApi - functional programming interface
 * @export
 */
export var ShopAreaApiFp = function (configuration) {
    return {
        /**
         *
         * @summary 店舗エリアマスタ一覧
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shopAreaList: function (options) {
            var localVarAxiosArgs = ShopAreaApiAxiosParamCreator(configuration).shopAreaList(options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
    };
};
/**
 * ShopAreaApi - factory interface
 * @export
 */
export var ShopAreaApiFactory = function (configuration, basePath, axios) {
    return {
        /**
         *
         * @summary 店舗エリアマスタ一覧
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shopAreaList: function (options) {
            return ShopAreaApiFp(configuration).shopAreaList(options)(axios, basePath);
        },
    };
};
/**
 * ShopAreaApi - object-oriented interface
 * @export
 * @class ShopAreaApi
 * @extends {BaseAPI}
 */
var ShopAreaApi = /** @class */ (function (_super) {
    __extends(ShopAreaApi, _super);
    function ShopAreaApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary 店舗エリアマスタ一覧
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopAreaApi
     */
    ShopAreaApi.prototype.shopAreaList = function (options) {
        return ShopAreaApiFp(this.configuration).shopAreaList(options)(this.axios, this.basePath);
    };
    return ShopAreaApi;
}(BaseAPI));
export { ShopAreaApi };
/**
 * ShopCategoryApi - axios parameter creator
 * @export
 */
export var ShopCategoryApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary 店舗カテゴリ一覧
         * @param {InlineObject10} [inlineObject10]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shopCategoryListCode: function (inlineObject10, options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/shop_category/list";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'POST' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("InlineObject10" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(inlineObject10 !== undefined ? inlineObject10 : {}) : (inlineObject10 || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * ShopCategoryApi - functional programming interface
 * @export
 */
export var ShopCategoryApiFp = function (configuration) {
    return {
        /**
         *
         * @summary 店舗カテゴリ一覧
         * @param {InlineObject10} [inlineObject10]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shopCategoryListCode: function (inlineObject10, options) {
            var localVarAxiosArgs = ShopCategoryApiAxiosParamCreator(configuration).shopCategoryListCode(inlineObject10, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
    };
};
/**
 * ShopCategoryApi - factory interface
 * @export
 */
export var ShopCategoryApiFactory = function (configuration, basePath, axios) {
    return {
        /**
         *
         * @summary 店舗カテゴリ一覧
         * @param {InlineObject10} [inlineObject10]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shopCategoryListCode: function (inlineObject10, options) {
            return ShopCategoryApiFp(configuration).shopCategoryListCode(inlineObject10, options)(axios, basePath);
        },
    };
};
/**
 * ShopCategoryApi - object-oriented interface
 * @export
 * @class ShopCategoryApi
 * @extends {BaseAPI}
 */
var ShopCategoryApi = /** @class */ (function (_super) {
    __extends(ShopCategoryApi, _super);
    function ShopCategoryApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary 店舗カテゴリ一覧
     * @param {InlineObject10} [inlineObject10]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopCategoryApi
     */
    ShopCategoryApi.prototype.shopCategoryListCode = function (inlineObject10, options) {
        return ShopCategoryApiFp(this.configuration).shopCategoryListCode(inlineObject10, options)(this.axios, this.basePath);
    };
    return ShopCategoryApi;
}(BaseAPI));
export { ShopCategoryApi };
/**
 * ShopGroupApi - axios parameter creator
 * @export
 */
export var ShopGroupApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary null
         * @param {ShopGroupFormAdd} shopGroupFormAdd
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shopGroupAdd: function (shopGroupFormAdd, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'shopGroupFormAdd' is not null or undefined
            if (shopGroupFormAdd === null || shopGroupFormAdd === undefined) {
                throw new RequiredError('shopGroupFormAdd', 'Required parameter shopGroupFormAdd was null or undefined when calling shopGroupAdd.');
            }
            var localVarPath = "/shop_group";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'POST' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("ShopGroupFormAdd" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(shopGroupFormAdd !== undefined ? shopGroupFormAdd : {}) : (shopGroupFormAdd || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 店舗グループ削除
         * @param {Array<object>} requestBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shopGroupDelete: function (requestBody, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'requestBody' is not null or undefined
            if (requestBody === null || requestBody === undefined) {
                throw new RequiredError('requestBody', 'Required parameter requestBody was null or undefined when calling shopGroupDelete.');
            }
            var localVarPath = "/shop_group";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'DELETE' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("Array&lt;object&gt;" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(requestBody !== undefined ? requestBody : {}) : (requestBody || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary null
         * @param {number} id 対象のID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shopGroupDetail: function (id, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id', 'Required parameter id was null or undefined when calling shopGroupDetail.');
            }
            var localVarPath = "/shop_group/{id}"
                .replace("{" + "id" + "}", encodeURIComponent(String(id)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 店舗グループダウンロード
         * @param {InlineObject4} [inlineObject4]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shopGroupDownload: function (inlineObject4, options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/shop_group/download";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'POST' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("InlineObject4" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(inlineObject4 !== undefined ? inlineObject4 : {}) : (inlineObject4 || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary null
         * @param {ShopGroupFormEdit} shopGroupFormEdit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shopGroupEdit: function (shopGroupFormEdit, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'shopGroupFormEdit' is not null or undefined
            if (shopGroupFormEdit === null || shopGroupFormEdit === undefined) {
                throw new RequiredError('shopGroupFormEdit', 'Required parameter shopGroupFormEdit was null or undefined when calling shopGroupEdit.');
            }
            var localVarPath = "/shop_group";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'PUT' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("ShopGroupFormEdit" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(shopGroupFormEdit !== undefined ? shopGroupFormEdit : {}) : (shopGroupFormEdit || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary null
         * @param {number} [pageNo] 表示するページ数
         * @param {number} [pageSize] ページ内に表示するリストの数。0の場合は全件取得する
         * @param {string} [sortField] ソート対象名
         * @param {string} [sortType] 昇順、降順(\&quot;-\&quot;:昇順、省略時:降順)
         * @param {string} [freeword] フリーワード検索
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shopGroupList: function (pageNo, pageSize, sortField, sortType, freeword, options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/shop_group/list";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (pageNo !== undefined) {
                localVarQueryParameter['page_no'] = pageNo;
            }
            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }
            if (sortField !== undefined) {
                localVarQueryParameter['sort_field'] = sortField;
            }
            if (sortType !== undefined) {
                localVarQueryParameter['sort_type'] = sortType;
            }
            if (freeword !== undefined) {
                localVarQueryParameter['freeword'] = freeword;
            }
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * ShopGroupApi - functional programming interface
 * @export
 */
export var ShopGroupApiFp = function (configuration) {
    return {
        /**
         *
         * @summary null
         * @param {ShopGroupFormAdd} shopGroupFormAdd
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shopGroupAdd: function (shopGroupFormAdd, options) {
            var localVarAxiosArgs = ShopGroupApiAxiosParamCreator(configuration).shopGroupAdd(shopGroupFormAdd, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary 店舗グループ削除
         * @param {Array<object>} requestBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shopGroupDelete: function (requestBody, options) {
            var localVarAxiosArgs = ShopGroupApiAxiosParamCreator(configuration).shopGroupDelete(requestBody, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary null
         * @param {number} id 対象のID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shopGroupDetail: function (id, options) {
            var localVarAxiosArgs = ShopGroupApiAxiosParamCreator(configuration).shopGroupDetail(id, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary 店舗グループダウンロード
         * @param {InlineObject4} [inlineObject4]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shopGroupDownload: function (inlineObject4, options) {
            var localVarAxiosArgs = ShopGroupApiAxiosParamCreator(configuration).shopGroupDownload(inlineObject4, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary null
         * @param {ShopGroupFormEdit} shopGroupFormEdit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shopGroupEdit: function (shopGroupFormEdit, options) {
            var localVarAxiosArgs = ShopGroupApiAxiosParamCreator(configuration).shopGroupEdit(shopGroupFormEdit, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary null
         * @param {number} [pageNo] 表示するページ数
         * @param {number} [pageSize] ページ内に表示するリストの数。0の場合は全件取得する
         * @param {string} [sortField] ソート対象名
         * @param {string} [sortType] 昇順、降順(\&quot;-\&quot;:昇順、省略時:降順)
         * @param {string} [freeword] フリーワード検索
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shopGroupList: function (pageNo, pageSize, sortField, sortType, freeword, options) {
            var localVarAxiosArgs = ShopGroupApiAxiosParamCreator(configuration).shopGroupList(pageNo, pageSize, sortField, sortType, freeword, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
    };
};
/**
 * ShopGroupApi - factory interface
 * @export
 */
export var ShopGroupApiFactory = function (configuration, basePath, axios) {
    return {
        /**
         *
         * @summary null
         * @param {ShopGroupFormAdd} shopGroupFormAdd
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shopGroupAdd: function (shopGroupFormAdd, options) {
            return ShopGroupApiFp(configuration).shopGroupAdd(shopGroupFormAdd, options)(axios, basePath);
        },
        /**
         *
         * @summary 店舗グループ削除
         * @param {Array<object>} requestBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shopGroupDelete: function (requestBody, options) {
            return ShopGroupApiFp(configuration).shopGroupDelete(requestBody, options)(axios, basePath);
        },
        /**
         *
         * @summary null
         * @param {number} id 対象のID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shopGroupDetail: function (id, options) {
            return ShopGroupApiFp(configuration).shopGroupDetail(id, options)(axios, basePath);
        },
        /**
         *
         * @summary 店舗グループダウンロード
         * @param {InlineObject4} [inlineObject4]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shopGroupDownload: function (inlineObject4, options) {
            return ShopGroupApiFp(configuration).shopGroupDownload(inlineObject4, options)(axios, basePath);
        },
        /**
         *
         * @summary null
         * @param {ShopGroupFormEdit} shopGroupFormEdit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shopGroupEdit: function (shopGroupFormEdit, options) {
            return ShopGroupApiFp(configuration).shopGroupEdit(shopGroupFormEdit, options)(axios, basePath);
        },
        /**
         *
         * @summary null
         * @param {number} [pageNo] 表示するページ数
         * @param {number} [pageSize] ページ内に表示するリストの数。0の場合は全件取得する
         * @param {string} [sortField] ソート対象名
         * @param {string} [sortType] 昇順、降順(\&quot;-\&quot;:昇順、省略時:降順)
         * @param {string} [freeword] フリーワード検索
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shopGroupList: function (pageNo, pageSize, sortField, sortType, freeword, options) {
            return ShopGroupApiFp(configuration).shopGroupList(pageNo, pageSize, sortField, sortType, freeword, options)(axios, basePath);
        },
    };
};
/**
 * ShopGroupApi - object-oriented interface
 * @export
 * @class ShopGroupApi
 * @extends {BaseAPI}
 */
var ShopGroupApi = /** @class */ (function (_super) {
    __extends(ShopGroupApi, _super);
    function ShopGroupApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary null
     * @param {ShopGroupFormAdd} shopGroupFormAdd
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopGroupApi
     */
    ShopGroupApi.prototype.shopGroupAdd = function (shopGroupFormAdd, options) {
        return ShopGroupApiFp(this.configuration).shopGroupAdd(shopGroupFormAdd, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary 店舗グループ削除
     * @param {Array<object>} requestBody
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopGroupApi
     */
    ShopGroupApi.prototype.shopGroupDelete = function (requestBody, options) {
        return ShopGroupApiFp(this.configuration).shopGroupDelete(requestBody, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary null
     * @param {number} id 対象のID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopGroupApi
     */
    ShopGroupApi.prototype.shopGroupDetail = function (id, options) {
        return ShopGroupApiFp(this.configuration).shopGroupDetail(id, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary 店舗グループダウンロード
     * @param {InlineObject4} [inlineObject4]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopGroupApi
     */
    ShopGroupApi.prototype.shopGroupDownload = function (inlineObject4, options) {
        return ShopGroupApiFp(this.configuration).shopGroupDownload(inlineObject4, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary null
     * @param {ShopGroupFormEdit} shopGroupFormEdit
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopGroupApi
     */
    ShopGroupApi.prototype.shopGroupEdit = function (shopGroupFormEdit, options) {
        return ShopGroupApiFp(this.configuration).shopGroupEdit(shopGroupFormEdit, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary null
     * @param {number} [pageNo] 表示するページ数
     * @param {number} [pageSize] ページ内に表示するリストの数。0の場合は全件取得する
     * @param {string} [sortField] ソート対象名
     * @param {string} [sortType] 昇順、降順(\&quot;-\&quot;:昇順、省略時:降順)
     * @param {string} [freeword] フリーワード検索
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopGroupApi
     */
    ShopGroupApi.prototype.shopGroupList = function (pageNo, pageSize, sortField, sortType, freeword, options) {
        return ShopGroupApiFp(this.configuration).shopGroupList(pageNo, pageSize, sortField, sortType, freeword, options)(this.axios, this.basePath);
    };
    return ShopGroupApi;
}(BaseAPI));
export { ShopGroupApi };
/**
 * ShopSearchApi - axios parameter creator
 * @export
 */
export var ShopSearchApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary 店舗取得（全て）
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shopSearchAll: function (options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/shop_search/all";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 店舗取得（店舗カテゴリ）
         * @param {InlineObject11} [inlineObject11]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shopSearchCategory: function (inlineObject11, options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/shop_search/category";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'POST' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("InlineObject11" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(inlineObject11 !== undefined ? inlineObject11 : {}) : (inlineObject11 || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 店舗取得（コード）
         * @param {InlineObject12} [inlineObject12]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shopSearchCode: function (inlineObject12, options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/shop_search/code";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'POST' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("InlineObject12" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(inlineObject12 !== undefined ? inlineObject12 : {}) : (inlineObject12 || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 店舗取得（店舗コードファイルアップロード）
         * @param {any} [file]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shopSearchFile: function (file, options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/shop_search/file";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'POST' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            var localVarFormParams = new FormData();
            if (file !== undefined) {
                localVarFormParams.append('file', file);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            localVarRequestOptions.data = localVarFormParams;
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 店舗取得（フリーワード）
         * @param {InlineObject14} [inlineObject14]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shopSearchFreeword: function (inlineObject14, options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/shop_search/freeword";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'POST' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("InlineObject14" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(inlineObject14 !== undefined ? inlineObject14 : {}) : (inlineObject14 || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 店舗取得（グループ）
         * @param {InlineObject15} [inlineObject15]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shopSearchGroup: function (inlineObject15, options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/shop_search/group";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'POST' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("InlineObject15" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(inlineObject15 !== undefined ? inlineObject15 : {}) : (inlineObject15 || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 店舗取得（名称）
         * @param {Array<InlineObject>} [inlineObject] code：取得したい店舗コード配列
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shopSearchName: function (inlineObject, options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/shop_search/name";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'POST' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("Array&lt;InlineObject&gt;" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(inlineObject !== undefined ? inlineObject : {}) : (inlineObject || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * ShopSearchApi - functional programming interface
 * @export
 */
export var ShopSearchApiFp = function (configuration) {
    return {
        /**
         *
         * @summary 店舗取得（全て）
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shopSearchAll: function (options) {
            var localVarAxiosArgs = ShopSearchApiAxiosParamCreator(configuration).shopSearchAll(options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary 店舗取得（店舗カテゴリ）
         * @param {InlineObject11} [inlineObject11]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shopSearchCategory: function (inlineObject11, options) {
            var localVarAxiosArgs = ShopSearchApiAxiosParamCreator(configuration).shopSearchCategory(inlineObject11, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary 店舗取得（コード）
         * @param {InlineObject12} [inlineObject12]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shopSearchCode: function (inlineObject12, options) {
            var localVarAxiosArgs = ShopSearchApiAxiosParamCreator(configuration).shopSearchCode(inlineObject12, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary 店舗取得（店舗コードファイルアップロード）
         * @param {any} [file]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shopSearchFile: function (file, options) {
            var localVarAxiosArgs = ShopSearchApiAxiosParamCreator(configuration).shopSearchFile(file, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary 店舗取得（フリーワード）
         * @param {InlineObject14} [inlineObject14]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shopSearchFreeword: function (inlineObject14, options) {
            var localVarAxiosArgs = ShopSearchApiAxiosParamCreator(configuration).shopSearchFreeword(inlineObject14, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary 店舗取得（グループ）
         * @param {InlineObject15} [inlineObject15]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shopSearchGroup: function (inlineObject15, options) {
            var localVarAxiosArgs = ShopSearchApiAxiosParamCreator(configuration).shopSearchGroup(inlineObject15, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary 店舗取得（名称）
         * @param {Array<InlineObject>} [inlineObject] code：取得したい店舗コード配列
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shopSearchName: function (inlineObject, options) {
            var localVarAxiosArgs = ShopSearchApiAxiosParamCreator(configuration).shopSearchName(inlineObject, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
    };
};
/**
 * ShopSearchApi - factory interface
 * @export
 */
export var ShopSearchApiFactory = function (configuration, basePath, axios) {
    return {
        /**
         *
         * @summary 店舗取得（全て）
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shopSearchAll: function (options) {
            return ShopSearchApiFp(configuration).shopSearchAll(options)(axios, basePath);
        },
        /**
         *
         * @summary 店舗取得（店舗カテゴリ）
         * @param {InlineObject11} [inlineObject11]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shopSearchCategory: function (inlineObject11, options) {
            return ShopSearchApiFp(configuration).shopSearchCategory(inlineObject11, options)(axios, basePath);
        },
        /**
         *
         * @summary 店舗取得（コード）
         * @param {InlineObject12} [inlineObject12]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shopSearchCode: function (inlineObject12, options) {
            return ShopSearchApiFp(configuration).shopSearchCode(inlineObject12, options)(axios, basePath);
        },
        /**
         *
         * @summary 店舗取得（店舗コードファイルアップロード）
         * @param {any} [file]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shopSearchFile: function (file, options) {
            return ShopSearchApiFp(configuration).shopSearchFile(file, options)(axios, basePath);
        },
        /**
         *
         * @summary 店舗取得（フリーワード）
         * @param {InlineObject14} [inlineObject14]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shopSearchFreeword: function (inlineObject14, options) {
            return ShopSearchApiFp(configuration).shopSearchFreeword(inlineObject14, options)(axios, basePath);
        },
        /**
         *
         * @summary 店舗取得（グループ）
         * @param {InlineObject15} [inlineObject15]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shopSearchGroup: function (inlineObject15, options) {
            return ShopSearchApiFp(configuration).shopSearchGroup(inlineObject15, options)(axios, basePath);
        },
        /**
         *
         * @summary 店舗取得（名称）
         * @param {Array<InlineObject>} [inlineObject] code：取得したい店舗コード配列
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shopSearchName: function (inlineObject, options) {
            return ShopSearchApiFp(configuration).shopSearchName(inlineObject, options)(axios, basePath);
        },
    };
};
/**
 * ShopSearchApi - object-oriented interface
 * @export
 * @class ShopSearchApi
 * @extends {BaseAPI}
 */
var ShopSearchApi = /** @class */ (function (_super) {
    __extends(ShopSearchApi, _super);
    function ShopSearchApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary 店舗取得（全て）
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopSearchApi
     */
    ShopSearchApi.prototype.shopSearchAll = function (options) {
        return ShopSearchApiFp(this.configuration).shopSearchAll(options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary 店舗取得（店舗カテゴリ）
     * @param {InlineObject11} [inlineObject11]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopSearchApi
     */
    ShopSearchApi.prototype.shopSearchCategory = function (inlineObject11, options) {
        return ShopSearchApiFp(this.configuration).shopSearchCategory(inlineObject11, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary 店舗取得（コード）
     * @param {InlineObject12} [inlineObject12]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopSearchApi
     */
    ShopSearchApi.prototype.shopSearchCode = function (inlineObject12, options) {
        return ShopSearchApiFp(this.configuration).shopSearchCode(inlineObject12, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary 店舗取得（店舗コードファイルアップロード）
     * @param {any} [file]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopSearchApi
     */
    ShopSearchApi.prototype.shopSearchFile = function (file, options) {
        return ShopSearchApiFp(this.configuration).shopSearchFile(file, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary 店舗取得（フリーワード）
     * @param {InlineObject14} [inlineObject14]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopSearchApi
     */
    ShopSearchApi.prototype.shopSearchFreeword = function (inlineObject14, options) {
        return ShopSearchApiFp(this.configuration).shopSearchFreeword(inlineObject14, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary 店舗取得（グループ）
     * @param {InlineObject15} [inlineObject15]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopSearchApi
     */
    ShopSearchApi.prototype.shopSearchGroup = function (inlineObject15, options) {
        return ShopSearchApiFp(this.configuration).shopSearchGroup(inlineObject15, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary 店舗取得（名称）
     * @param {Array<InlineObject>} [inlineObject] code：取得したい店舗コード配列
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopSearchApi
     */
    ShopSearchApi.prototype.shopSearchName = function (inlineObject, options) {
        return ShopSearchApiFp(this.configuration).shopSearchName(inlineObject, options)(this.axios, this.basePath);
    };
    return ShopSearchApi;
}(BaseAPI));
export { ShopSearchApi };
/**
 * SiteApi - axios parameter creator
 * @export
 */
export var SiteApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary 未ログイン対象のサイト基本情報を取得する
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        site: function (options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/site";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'POST' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * SiteApi - functional programming interface
 * @export
 */
export var SiteApiFp = function (configuration) {
    return {
        /**
         *
         * @summary 未ログイン対象のサイト基本情報を取得する
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        site: function (options) {
            var localVarAxiosArgs = SiteApiAxiosParamCreator(configuration).site(options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
    };
};
/**
 * SiteApi - factory interface
 * @export
 */
export var SiteApiFactory = function (configuration, basePath, axios) {
    return {
        /**
         *
         * @summary 未ログイン対象のサイト基本情報を取得する
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        site: function (options) {
            return SiteApiFp(configuration).site(options)(axios, basePath);
        },
    };
};
/**
 * SiteApi - object-oriented interface
 * @export
 * @class SiteApi
 * @extends {BaseAPI}
 */
var SiteApi = /** @class */ (function (_super) {
    __extends(SiteApi, _super);
    function SiteApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary 未ログイン対象のサイト基本情報を取得する
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SiteApi
     */
    SiteApi.prototype.site = function (options) {
        return SiteApiFp(this.configuration).site(options)(this.axios, this.basePath);
    };
    return SiteApi;
}(BaseAPI));
export { SiteApi };
/**
 * SupplierApi - axios parameter creator
 * @export
 */
export var SupplierApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary 取引先一覧
         * @param {number} [pageNo] 表示するページ数
         * @param {number} [pageSize] ページ内に表示するリストの数。0の場合は全件取得する
         * @param {string} [sortField] ソート対象名
         * @param {string} [sortType] 昇順、降順(\&quot;-\&quot;:昇順、省略時:降順)
         * @param {string} [freeword] フリーワード検索
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supplierList: function (pageNo, pageSize, sortField, sortType, freeword, options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/supplier/list";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (pageNo !== undefined) {
                localVarQueryParameter['page_no'] = pageNo;
            }
            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }
            if (sortField !== undefined) {
                localVarQueryParameter['sort_field'] = sortField;
            }
            if (sortType !== undefined) {
                localVarQueryParameter['sort_type'] = sortType;
            }
            if (freeword !== undefined) {
                localVarQueryParameter['freeword'] = freeword;
            }
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * SupplierApi - functional programming interface
 * @export
 */
export var SupplierApiFp = function (configuration) {
    return {
        /**
         *
         * @summary 取引先一覧
         * @param {number} [pageNo] 表示するページ数
         * @param {number} [pageSize] ページ内に表示するリストの数。0の場合は全件取得する
         * @param {string} [sortField] ソート対象名
         * @param {string} [sortType] 昇順、降順(\&quot;-\&quot;:昇順、省略時:降順)
         * @param {string} [freeword] フリーワード検索
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supplierList: function (pageNo, pageSize, sortField, sortType, freeword, options) {
            var localVarAxiosArgs = SupplierApiAxiosParamCreator(configuration).supplierList(pageNo, pageSize, sortField, sortType, freeword, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
    };
};
/**
 * SupplierApi - factory interface
 * @export
 */
export var SupplierApiFactory = function (configuration, basePath, axios) {
    return {
        /**
         *
         * @summary 取引先一覧
         * @param {number} [pageNo] 表示するページ数
         * @param {number} [pageSize] ページ内に表示するリストの数。0の場合は全件取得する
         * @param {string} [sortField] ソート対象名
         * @param {string} [sortType] 昇順、降順(\&quot;-\&quot;:昇順、省略時:降順)
         * @param {string} [freeword] フリーワード検索
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supplierList: function (pageNo, pageSize, sortField, sortType, freeword, options) {
            return SupplierApiFp(configuration).supplierList(pageNo, pageSize, sortField, sortType, freeword, options)(axios, basePath);
        },
    };
};
/**
 * SupplierApi - object-oriented interface
 * @export
 * @class SupplierApi
 * @extends {BaseAPI}
 */
var SupplierApi = /** @class */ (function (_super) {
    __extends(SupplierApi, _super);
    function SupplierApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary 取引先一覧
     * @param {number} [pageNo] 表示するページ数
     * @param {number} [pageSize] ページ内に表示するリストの数。0の場合は全件取得する
     * @param {string} [sortField] ソート対象名
     * @param {string} [sortType] 昇順、降順(\&quot;-\&quot;:昇順、省略時:降順)
     * @param {string} [freeword] フリーワード検索
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupplierApi
     */
    SupplierApi.prototype.supplierList = function (pageNo, pageSize, sortField, sortType, freeword, options) {
        return SupplierApiFp(this.configuration).supplierList(pageNo, pageSize, sortField, sortType, freeword, options)(this.axios, this.basePath);
    };
    return SupplierApi;
}(BaseAPI));
export { SupplierApi };
/**
 * UserApi - axios parameter creator
 * @export
 */
export var UserApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary ユーザ登録
         * @param {UserModel} userModel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userAdd: function (userModel, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'userModel' is not null or undefined
            if (userModel === null || userModel === undefined) {
                throw new RequiredError('userModel', 'Required parameter userModel was null or undefined when calling userAdd.');
            }
            var localVarPath = "/user";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'POST' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("UserModel" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(userModel !== undefined ? userModel : {}) : (userModel || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary ユーザ削除
         * @param {Array<object>} requestBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userDelete: function (requestBody, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'requestBody' is not null or undefined
            if (requestBody === null || requestBody === undefined) {
                throw new RequiredError('requestBody', 'Required parameter requestBody was null or undefined when calling userDelete.');
            }
            var localVarPath = "/user";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'DELETE' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("Array&lt;object&gt;" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(requestBody !== undefined ? requestBody : {}) : (requestBody || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary ユーザ詳細
         * @param {number} id 対象のID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userDetail: function (id, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id', 'Required parameter id was null or undefined when calling userDetail.');
            }
            var localVarPath = "/user/{id}"
                .replace("{" + "id" + "}", encodeURIComponent(String(id)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary ユーザ更新
         * @param {User} user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userEdit: function (user, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'user' is not null or undefined
            if (user === null || user === undefined) {
                throw new RequiredError('user', 'Required parameter user was null or undefined when calling userEdit.');
            }
            var localVarPath = "/user";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'PUT' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("User" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(user !== undefined ? user : {}) : (user || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary ユーザ更新（自分自身の情報）
         * @param {UserEdit} userEdit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userEditMe: function (userEdit, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'userEdit' is not null or undefined
            if (userEdit === null || userEdit === undefined) {
                throw new RequiredError('userEdit', 'Required parameter userEdit was null or undefined when calling userEditMe.');
            }
            var localVarPath = "/user/edit_me";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'POST' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("UserEdit" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(userEdit !== undefined ? userEdit : {}) : (userEdit || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary ユーザ一覧
         * @param {number} [pageNo] 表示するページ数
         * @param {number} [pageSize] ページ内に表示するリストの数。0の場合は全件取得する
         * @param {string} [sortField] ソート対象名
         * @param {string} [sortType] 昇順、降順(\&quot;-\&quot;:昇順、省略時:降順)
         * @param {string} [freeword] フリーワード検索
         * @param {number} [contractId] 企業ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userList: function (pageNo, pageSize, sortField, sortType, freeword, contractId, options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/user/list";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (pageNo !== undefined) {
                localVarQueryParameter['page_no'] = pageNo;
            }
            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }
            if (sortField !== undefined) {
                localVarQueryParameter['sort_field'] = sortField;
            }
            if (sortType !== undefined) {
                localVarQueryParameter['sort_type'] = sortType;
            }
            if (freeword !== undefined) {
                localVarQueryParameter['freeword'] = freeword;
            }
            if (contractId !== undefined) {
                localVarQueryParameter['contract_id'] = contractId;
            }
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary registration_token情報更新
         * @param {InlineObject1} [inlineObject1]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userRegistrationToken: function (inlineObject1, options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/user/registration_token";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'POST' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("InlineObject1" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(inlineObject1 !== undefined ? inlineObject1 : {}) : (inlineObject1 || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 2要素認証フラグ更新
         * @param {InlineObjectMfa} [inlineObjectMfa]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userMfa: function (inlineObjectMfa, options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/user/mfa";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'POST' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("InlineObjectMfa" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(inlineObjectMfa !== undefined ? inlineObjectMfa : {}) : (inlineObjectMfa || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary ユーザ詳細（自分自身の情報取得）
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userSelf: function (options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/user";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * UserApi - functional programming interface
 * @export
 */
export var UserApiFp = function (configuration) {
    return {
        /**
         *
         * @summary ユーザ登録
         * @param {UserModel} userModel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userAdd: function (userModel, options) {
            var localVarAxiosArgs = UserApiAxiosParamCreator(configuration).userAdd(userModel, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary ユーザ削除
         * @param {Array<object>} requestBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userDelete: function (requestBody, options) {
            var localVarAxiosArgs = UserApiAxiosParamCreator(configuration).userDelete(requestBody, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary ユーザ詳細
         * @param {number} id 対象のID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userDetail: function (id, options) {
            var localVarAxiosArgs = UserApiAxiosParamCreator(configuration).userDetail(id, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary ユーザ更新
         * @param {User} user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userEdit: function (user, options) {
            var localVarAxiosArgs = UserApiAxiosParamCreator(configuration).userEdit(user, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary ユーザ更新（自分自身の情報）
         * @param {UserEdit} userEdit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userEditMe: function (userEdit, options) {
            var localVarAxiosArgs = UserApiAxiosParamCreator(configuration).userEditMe(userEdit, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary ユーザ一覧
         * @param {number} [pageNo] 表示するページ数
         * @param {number} [pageSize] ページ内に表示するリストの数。0の場合は全件取得する
         * @param {string} [sortField] ソート対象名
         * @param {string} [sortType] 昇順、降順(\&quot;-\&quot;:昇順、省略時:降順)
         * @param {string} [freeword] フリーワード検索
         * @param {number} [contractId] 企業ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userList: function (pageNo, pageSize, sortField, sortType, freeword, contractId, options) {
            var localVarAxiosArgs = UserApiAxiosParamCreator(configuration).userList(pageNo, pageSize, sortField, sortType, freeword, contractId, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary registration_token情報更新
         * @param {InlineObject1} [inlineObject1]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userRegistrationToken: function (inlineObject1, options) {
            var localVarAxiosArgs = UserApiAxiosParamCreator(configuration).userRegistrationToken(inlineObject1, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary 2要素認証フラグ更新
         * @param {InlineObjectMfa} [inlineObjectMfa]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userMfa: function (inlineObjectMfa, options) {
            var localVarAxiosArgs = UserApiAxiosParamCreator(configuration).userMfa(inlineObjectMfa, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary ユーザ詳細（自分自身の情報取得）
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userSelf: function (options) {
            var localVarAxiosArgs = UserApiAxiosParamCreator(configuration).userSelf(options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
    };
};
/**
 * UserApi - factory interface
 * @export
 */
export var UserApiFactory = function (configuration, basePath, axios) {
    return {
        /**
         *
         * @summary ユーザ登録
         * @param {UserModel} userModel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userAdd: function (userModel, options) {
            return UserApiFp(configuration).userAdd(userModel, options)(axios, basePath);
        },
        /**
         *
         * @summary ユーザ削除
         * @param {Array<object>} requestBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userDelete: function (requestBody, options) {
            return UserApiFp(configuration).userDelete(requestBody, options)(axios, basePath);
        },
        /**
         *
         * @summary ユーザ詳細
         * @param {number} id 対象のID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userDetail: function (id, options) {
            return UserApiFp(configuration).userDetail(id, options)(axios, basePath);
        },
        /**
         *
         * @summary ユーザ更新
         * @param {User} user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userEdit: function (user, options) {
            return UserApiFp(configuration).userEdit(user, options)(axios, basePath);
        },
        /**
         *
         * @summary ユーザ更新（自分自身の情報）
         * @param {UserEdit} userEdit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userEditMe: function (userEdit, options) {
            return UserApiFp(configuration).userEditMe(userEdit, options)(axios, basePath);
        },
        /**
         *
         * @summary ユーザ一覧
         * @param {number} [pageNo] 表示するページ数
         * @param {number} [pageSize] ページ内に表示するリストの数。0の場合は全件取得する
         * @param {string} [sortField] ソート対象名
         * @param {string} [sortType] 昇順、降順(\&quot;-\&quot;:昇順、省略時:降順)
         * @param {string} [freeword] フリーワード検索
         * @param {number} [contractId] 企業ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userList: function (pageNo, pageSize, sortField, sortType, freeword, contractId, options) {
            return UserApiFp(configuration).userList(pageNo, pageSize, sortField, sortType, freeword, contractId, options)(axios, basePath);
        },
        /**
         *
         * @summary registration_token情報更新
         * @param {InlineObject1} [inlineObject1]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userRegistrationToken: function (inlineObject1, options) {
            return UserApiFp(configuration).userRegistrationToken(inlineObject1, options)(axios, basePath);
        },
        /**
         *
         * @summary 2要素認証フラグ更新
         * @param {InlineObjectMfa} [inlineObjectMfa]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userMfa: function (inlineObjectMfa, options) {
            return UserApiFp(configuration).userMfa(inlineObjectMfa, options)(axios, basePath);
        },
        /**
         *
         * @summary ユーザ詳細（自分自身の情報取得）
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userSelf: function (options) {
            return UserApiFp(configuration).userSelf(options)(axios, basePath);
        },
    };
};
/**
 * UserApi - object-oriented interface
 * @export
 * @class UserApi
 * @extends {BaseAPI}
 */
var UserApi = /** @class */ (function (_super) {
    __extends(UserApi, _super);
    function UserApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary ユーザ登録
     * @param {UserModel} userModel
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    UserApi.prototype.userAdd = function (userModel, options) {
        return UserApiFp(this.configuration).userAdd(userModel, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary ユーザ削除
     * @param {Array<object>} requestBody
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    UserApi.prototype.userDelete = function (requestBody, options) {
        return UserApiFp(this.configuration).userDelete(requestBody, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary ユーザ詳細
     * @param {number} id 対象のID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    UserApi.prototype.userDetail = function (id, options) {
        return UserApiFp(this.configuration).userDetail(id, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary ユーザ更新
     * @param {User} user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    UserApi.prototype.userEdit = function (user, options) {
        return UserApiFp(this.configuration).userEdit(user, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary ユーザ更新（自分自身の情報）
     * @param {UserEdit} userEdit
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    UserApi.prototype.userEditMe = function (userEdit, options) {
        return UserApiFp(this.configuration).userEditMe(userEdit, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary ユーザ一覧
     * @param {number} [pageNo] 表示するページ数
     * @param {number} [pageSize] ページ内に表示するリストの数。0の場合は全件取得する
     * @param {string} [sortField] ソート対象名
     * @param {string} [sortType] 昇順、降順(\&quot;-\&quot;:昇順、省略時:降順)
     * @param {string} [freeword] フリーワード検索
     * @param {number} [contractId] 企業ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    UserApi.prototype.userList = function (pageNo, pageSize, sortField, sortType, freeword, contractId, options) {
        return UserApiFp(this.configuration).userList(pageNo, pageSize, sortField, sortType, freeword, contractId, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary registration_token情報更新
     * @param {InlineObject1} [inlineObject1]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    UserApi.prototype.userRegistrationToken = function (inlineObject1, options) {
        return UserApiFp(this.configuration).userRegistrationToken(inlineObject1, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary 2要素認証フラグ更新
     * @param {InlineObjectMfa} [inlineObjectMfa]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    UserApi.prototype.userMfa = function (inlineObjectMfa, options) {
        return UserApiFp(this.configuration).userMfa(inlineObjectMfa, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary ユーザ詳細（自分自身の情報取得）
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    UserApi.prototype.userSelf = function (options) {
        return UserApiFp(this.configuration).userSelf(options)(this.axios, this.basePath);
    };
    return UserApi;
}(BaseAPI));
export { UserApi };
